/**
 * ═══════════════════════════════════════════════
 * Atlantide Theme JS — v2.4 perf-opt
 * Atlantide Gioielli — Shopify Theme JavaScript
 * Minimal luxury · Stainless steel jewelry
 * ═══════════════════════════════════════════════
 */

(function() {
  'use strict';

  /* ── Category Strip Swipe Indicator ───────────────────── */
  document.querySelectorAll('.category-strip__scroll').forEach(track => {
    const wrapper = track.closest('.category-strip__scroll-wrapper');
    if (!wrapper) return;
    const indicator = wrapper.querySelector('.category-strip__swipe-indicator');
    if (!indicator) return;
    
    const hideIndicator = () => {
      if (track.scrollLeft > 10 && !indicator.classList.contains('is-hidden')) {
        indicator.classList.add('is-hidden');
        track.removeEventListener('scroll', hideIndicator);
      }
    };
    track.addEventListener('scroll', hideIndicator, { passive: true });
  });

  function initDraggableSlider(slider) {
    if (!slider || slider.dataset.dragInitialized) return;
    slider.dataset.dragInitialized = 'true';
    let isDown = false, isDragging = false, startX, scrollLeft;
    slider.addEventListener('mousedown', (e) => {
      isDown = true; isDragging = false; 
      startX = e.pageX - slider.offsetLeft; scrollLeft = slider.scrollLeft;
      if (!e.target.closest('button') && !e.target.closest('input')) e.preventDefault();
    });
    slider.addEventListener('mouseleave', () => { isDown = false; });
    slider.addEventListener('mouseup', () => { isDown = false; });
    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      const x = e.pageX - slider.offsetLeft;
      if (Math.abs(x - startX) > 5) {
        isDragging = true;
        slider.scrollLeft = scrollLeft - (x - startX);
      }
    });
    slider.addEventListener('click', (e) => {
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  /* ── Sticky Header (transparent → frosted glass) ───────── */
  const header = document.getElementById('site-header');
  const announcementBar = document.getElementById('announcement-bar');
  const isHomepage = document.body.classList.contains('template-index');
  const hasAnnouncement = document.body.classList.contains('has-announcement');

  if (header) {
    const onScroll = () => {
      const y = window.scrollY;
      if (y > 100) {
        if (isHomepage) {
          header.classList.remove('site-header--transparent');
        }
        header.classList.add('site-header--scrolled');
        // Hide announcement bar; `announcement-hidden` only slides the header
        // to top:0 — `has-announcement` stays on <body> so the page padding
        // doesn't change and content doesn't jump 40px mid-scroll.
        if (announcementBar) {
          announcementBar.classList.add('is-hidden');
          document.body.classList.add('announcement-hidden');
        }
      } else {
        if (isHomepage) {
          header.classList.add('site-header--transparent');
          header.classList.remove('site-header--scrolled');
        }
        // Show announcement bar when at top
        if (announcementBar && !announcementBar.dataset.dismissed && hasAnnouncement) {
          announcementBar.classList.remove('is-hidden');
          document.body.classList.remove('announcement-hidden');
        }
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile Menu ──────────────────────────────────────── */
  const mobileMenu = document.getElementById('mobile-menu');
  const menuToggle = document.getElementById('menu-toggle');
  const menuClose = document.getElementById('mobile-menu-close');

  let menuSavedScrollY = 0;

  const closeMenu = () => {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-is-open');
    document.body.style.top = '';
    restoreScrollInstant(menuSavedScrollY);
  };

  if (mobileMenu && menuToggle) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      // Save scroll before the body becomes position:fixed, like the cart
      // drawer does — otherwise closing the menu strands you at the top.
      menuSavedScrollY = window.scrollY;
      document.body.style.top = `-${menuSavedScrollY}px`;
      document.body.classList.add('cart-is-open');
    });

    if (menuClose) menuClose.addEventListener('click', closeMenu);
    mobileMenu.addEventListener('click', (e) => {
      if (e.target === mobileMenu) closeMenu();
    });
  }

  /* ── Desktop Nav Dropdowns (hover) ───────────────────── */
  document.querySelectorAll('[data-dropdown]').forEach(dd => {
    let timer;
    const open = () => { clearTimeout(timer); dd.classList.add('is-open'); dd.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'true'); };
    const close = () => { timer = setTimeout(() => { dd.classList.remove('is-open'); dd.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'false'); }, 200); };
    dd.addEventListener('mouseenter', open);
    dd.addEventListener('mouseleave', close);
    // Also toggle on click (for touch screens)
    const trigger = dd.querySelector('.header__dropdown-trigger');
    if (trigger) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        dd.classList.contains('is-open') ? close() : open();
      });
    }
  });

  /* ── Mobile Menu Accordion ───────────────────────────── */
  document.querySelectorAll('[data-mobile-dropdown]').forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
    });
  });

  /* ── Cart Drawer ──────────────────────────────────────── */
  const cartDrawer = document.getElementById('cart-drawer');
  const cartToggle = document.getElementById('cart-toggle');
  const cartClose = document.getElementById('cart-drawer-close');
  const cartBackdrop = document.getElementById('cart-drawer-backdrop');
  let savedScrollY = 0;

  const openCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    savedScrollY = window.scrollY;
    document.body.style.top = `-${savedScrollY}px`;
    document.body.classList.add('cart-is-open');
  };

  // Restore a scroll position without the html { scroll-behavior: smooth }
  // rule animating the jump (visible as a slow scroll from the top).
  const restoreScrollInstant = (y) => {
    const html = document.documentElement;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
    html.style.scrollBehavior = '';
  };

  const closeCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-is-open');
    document.body.style.top = '';
    restoreScrollInstant(savedScrollY);
  };

  if (cartDrawer && cartToggle) {
    cartToggle.addEventListener('click', openCart);
    if (cartClose) cartClose.addEventListener('click', closeCart);
    if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);

    // Auto-open if redirected from standalone cart page
    if (window.location.hash === '#cart') {
      setTimeout(() => {
        openCart();
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, null, window.location.pathname);
        }
      }, 100);
    }

    // Auto-open cart if redirected after add-to-cart
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('cart_open')) {
      openCart();
      // Clean URL
      urlParams.delete('cart_open');
      const cleanUrl = urlParams.toString()
        ? `${window.location.pathname}?${urlParams.toString()}`
        : window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
    }
  }

  /* ── Announcement Bar Dismiss ─────────────────────────── */
  const announcementClose = document.getElementById('announcement-close');
  if (announcementClose && announcementBar) {
    announcementClose.addEventListener('click', () => {
      announcementBar.classList.add('is-hidden');
      announcementBar.dataset.dismissed = 'true';
      document.body.classList.remove('has-announcement');
    });
  }

  /* ── Announcement Ticker — fill wide screens ──────────── */
  // Liquid renders the message set twice and the CSS loop translates the
  // track by -50%. On wide screens a single set can be narrower than the
  // bar, so the tail of the track passes and the right side goes empty.
  // Clone the set until one half of the track covers the bar, and scale
  // the animation duration so the scrolling speed stays the same.
  const announcementTrack = document.getElementById('announcement-track');
  if (announcementTrack && announcementBar) {
    const ticker = announcementTrack.parentElement;
    const setItems = Array.from(announcementTrack.children)
      .slice(0, announcementTrack.children.length / 2)
      .map((el) => el.cloneNode(true));
    const setWidth = announcementTrack.scrollWidth / 2;
    const baseSpeed = parseFloat(
      getComputedStyle(announcementBar).getPropertyValue('--ticker-speed')
    ) || 30;
    let tickerCopies = 1; // message-set copies per track half

    const fillTicker = () => {
      if (!setWidth) return;
      const needed = Math.max(1, Math.ceil(ticker.clientWidth / setWidth));
      if (needed <= tickerCopies) return;
      for (let k = tickerCopies; k < needed; k++) {
        const midPoint = announcementTrack.children[announcementTrack.children.length / 2];
        setItems.forEach((item) => {
          const mid = item.cloneNode(true);
          const tail = item.cloneNode(true);
          [mid, tail].forEach((clone) => {
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a').forEach((a) => { a.tabIndex = -1; });
          });
          announcementTrack.insertBefore(mid, midPoint); // grow first half
          announcementTrack.appendChild(tail);           // grow second half
        });
      }
      tickerCopies = needed;
      announcementTrack.style.animationDuration = (baseSpeed * tickerCopies) + 's';
    };

    fillTicker();
    window.addEventListener('resize', fillTicker, { passive: true });
  }

  /* ── Product Image Gallery ────────────────────────────── */
  let pdpGoToSlide = null; // Exposed for variant selector
  const galleryTrack = document.getElementById('gallery-track');
  const galleryDots = document.getElementById('gallery-dots');

  if (galleryTrack) {
    const slides = galleryTrack.querySelectorAll('.pdp__slide');
    const dots = galleryDots ? galleryDots.querySelectorAll('.pdp__dot') : [];
    const thumbs = document.querySelectorAll('.pdp__thumb');
    const prevBtn = document.getElementById('gallery-prev');
    const nextBtn = document.getElementById('gallery-next');
    const counter = document.getElementById('gallery-counter');

    // ── Reliable gallery image loading ───────────────────────────
    // The swiper reveals slides via CSS transform, so the browser's native
    // loading="lazy" never fires for the off-screen slides (it uses their
    // pre-transform layout position) — leaving 2nd+ images blank. Load each
    // slide's image explicitly when it's shown, and retry once on error so a
    // transient network blip can't leave a permanently-broken image.
    const ensureImgLoaded = (img) => {
      if (!img || (img.complete && img.naturalWidth > 0)) return;
      const src = img.getAttribute('src');
      if (!src) return;
      if (!img.dataset.atlBound) {
        img.dataset.atlBound = '1';
        img.addEventListener('error', () => {
          if (img.dataset.atlRetried) return;
          img.dataset.atlRetried = '1';
          setTimeout(() => { img.loading = 'eager'; img.src = src; }, 800);
        });
      }
      img.loading = 'eager';
      img.src = src;
    };
    const loadSlideImage = (i) => {
      const slide = slides[i];
      if (slide) ensureImgLoaded(slide.querySelector('img'));
    };
    // preload the next slide + every thumbnail up front (slide 0 is eager)
    loadSlideImage(1);
    thumbs.forEach((t) => ensureImgLoaded(t.querySelector('img')));

    let currentSlide = 0;
    let startX = 0;
    let isDragging = false;
    let dragOffset = 0;

    const goToSlide = (index) => {
      currentSlide = Math.max(0, Math.min(index, slides.length - 1));
      loadSlideImage(currentSlide);      // ensure the shown slide's image is loaded
      loadSlideImage(currentSlide + 1);  // preload the next one
      const container = galleryTrack.closest('.pdp__swiper-container') || galleryTrack.parentElement;
      const w = container.offsetWidth;
      galleryTrack.style.transform = `translateX(-${currentSlide * w}px)`;

      dots.forEach((d, i) => d.classList.toggle('is-active', i === currentSlide));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === currentSlide));
      if (counter) counter.textContent = `${currentSlide + 1} / ${slides.length}`;

      // Update arrow visibility
      if (prevBtn) prevBtn.style.display = currentSlide === 0 ? 'none' : '';
      if (nextBtn) nextBtn.style.display = currentSlide === slides.length - 1 ? 'none' : '';
    };
    pdpGoToSlide = goToSlide; // Expose to module scope

    // Initialize: hide prev arrow on first slide
    if (prevBtn) prevBtn.style.display = 'none';

    // Arrow clicks
    if (prevBtn) prevBtn.addEventListener('click', () => goToSlide(currentSlide - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goToSlide(currentSlide + 1));

    // Touch/mouse swipe
    const onStart = (x) => { isDragging = true; startX = x; dragOffset = 0; galleryTrack.style.transition = 'none'; };
    const onMove = (x) => {
      if (!isDragging) return;
      dragOffset = x - startX;
      const container = galleryTrack.closest('.pdp__swiper-container') || galleryTrack.parentElement;
      const w = container.offsetWidth;
      const base = -(currentSlide * w);
      let offset = dragOffset;
      if ((currentSlide === 0 && offset > 0) || (currentSlide === slides.length - 1 && offset < 0)) {
        offset *= 0.3;
      }
      galleryTrack.style.transform = `translateX(${base + offset}px)`;
    };
    const onEnd = () => {
      if (!isDragging) return;
      isDragging = false;
      galleryTrack.style.transition = '';
      const container = galleryTrack.closest('.pdp__swiper-container') || galleryTrack.parentElement;
      const threshold = container.offsetWidth * 0.2;
      if (dragOffset < -threshold) goToSlide(currentSlide + 1);
      else if (dragOffset > threshold) goToSlide(currentSlide - 1);
      else goToSlide(currentSlide);
    };

    galleryTrack.addEventListener('touchstart', (e) => onStart(e.touches[0].clientX), { passive: true });
    galleryTrack.addEventListener('touchmove', (e) => onMove(e.touches[0].clientX), { passive: true });
    galleryTrack.addEventListener('touchend', onEnd);
    galleryTrack.addEventListener('mousedown', (e) => { e.preventDefault(); onStart(e.clientX); });
    galleryTrack.addEventListener('mousemove', (e) => onMove(e.clientX));
    galleryTrack.addEventListener('mouseup', onEnd);
    galleryTrack.addEventListener('mouseleave', () => { if (isDragging) onEnd(); });

    // Dots click
    dots.forEach((dot) => {
      dot.addEventListener('click', () => goToSlide(parseInt(dot.dataset.index)));
    });

    // Thumbnails click
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => goToSlide(parseInt(thumb.dataset.index)));
    });

    // Handle resize
    window.addEventListener('resize', () => goToSlide(currentSlide));
  }

  // Jump the gallery to a slide without animating (used on initial load so
  // the pre-selected variant's photo shows instead of always slide 1).
  const jumpGalleryTo = (idx) => {
    if (!pdpGoToSlide || !galleryTrack || !(idx > 0)) return;
    galleryTrack.style.transition = 'none';
    pdpGoToSlide(idx);
    requestAnimationFrame(() => { galleryTrack.style.transition = ''; });
  };

  /* ── Variant Selector ─────────────────────────────────── */
  const lowStockAlert = document.getElementById('low-stock-alert');
  let variantInventory = {};
  try {
    const invEl = document.getElementById('variant-inventory');
    if (invEl) variantInventory = JSON.parse(invEl.textContent);
  } catch (e) {}

  const updateLowStock = (variantId) => {
    if (!lowStockAlert) return;
    const info = variantInventory[variantId];
    if (info && info.managed === 'shopify' && info.qty > 0 && info.qty <= 2) {
      const text = info.qty === 1
        ? 'Ultimo pezzo disponibile!'
        : `Solo ${info.qty} pezzi rimasti!`;
      lowStockAlert.innerHTML = '<span class="pdp__low-stock-dot"></span>' + text;
      lowStockAlert.style.display = '';
    } else {
      lowStockAlert.style.display = 'none';
    }
  };

  /* ── Single-option flat variant buttons ─────────────── */
  const variantOptions = document.getElementById('variant-options');
  if (variantOptions) {
    const buttons = variantOptions.querySelectorAll('.pdp__variant-btn');
    const variantIdInput = document.getElementById('variant-id');
    const variantNameEl = document.getElementById('variant-name');
    const priceEl = document.getElementById('product-price');
    const compareEl = document.getElementById('product-compare-price');
    const stickyPriceEl = document.getElementById('sticky-price');
    const addBtn = document.getElementById('add-to-cart-btn');
    const addText = document.getElementById('add-to-cart-text');

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        buttons.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        if (variantIdInput) variantIdInput.value = btn.dataset.variantId;
        if (variantNameEl) variantNameEl.textContent = btn.dataset.variantTitle;
        if (priceEl) priceEl.textContent = btn.dataset.variantPrice;
        if (compareEl && btn.dataset.variantCompare) {
          compareEl.textContent = btn.dataset.variantCompare;
        }
        if (stickyPriceEl) stickyPriceEl.textContent = btn.dataset.variantPrice;

        const available = btn.dataset.variantAvailable === 'true';
        if (addBtn) addBtn.disabled = !available;
        if (addBtn) addBtn.classList.toggle('btn--disabled', !available);
        if (addText) addText.textContent = available ? 'Aggiungi al Carrello' : 'Non Disponibile';

        const buyNowBtn = document.getElementById('go-to-checkout-btn');
        if (buyNowBtn) buyNowBtn.disabled = !available;

        if (btn.dataset.imagePosition && pdpGoToSlide) {
          pdpGoToSlide(parseInt(btn.dataset.imagePosition) - 1);
        }

        updateLowStock(btn.dataset.variantId);
      });
    });

    // On load, show the pre-selected variant's image (the gallery otherwise
    // starts on slide 1, which can belong to a different — even sold-out — variant)
    const initialBtn = variantOptions.querySelector('.pdp__variant-btn.is-active');
    if (initialBtn && initialBtn.dataset.imagePosition) {
      jumpGalleryTo(parseInt(initialBtn.dataset.imagePosition) - 1);
    }
  }

  /* ── Multi-option variant selector ─────────────────── */
  const variantSelector = document.getElementById('variant-selector');
  if (variantSelector) {
    let allVariants = [];
    try {
      const jsonEl = document.getElementById('product-variants-json');
      if (jsonEl) allVariants = JSON.parse(jsonEl.textContent);
    } catch (e) {}

    const selectedOptions = {};
    const initVariant = allVariants.find(v => v.available) || allVariants[0];
    if (initVariant) {
      initVariant.options.forEach((val, i) => { selectedOptions[i + 1] = val; });
    }

    const findVariant = () => {
      return allVariants.find(v =>
        v.options.every((opt, i) => selectedOptions[i + 1] === opt)
      );
    };

    const applyVariant = (variant) => {
      if (!variant) return;
      const variantIdInput = document.getElementById('variant-id');
      const priceEl = document.getElementById('product-price');
      const compareEl = document.getElementById('product-compare-price');
      const stickyPriceEl = document.getElementById('sticky-price');
      const addBtn = document.getElementById('add-to-cart-btn');
      const addText = document.getElementById('add-to-cart-text');
      const buyNowBtn = document.getElementById('go-to-checkout-btn');

      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price_fmt;
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = variant.compare_fmt;
          compareEl.style.display = '';
          priceEl.classList.add('pdp__price--sale');
        } else {
          compareEl.style.display = 'none';
          priceEl.classList.remove('pdp__price--sale');
        }
      }
      if (stickyPriceEl) stickyPriceEl.textContent = variant.price_fmt;

      if (addBtn) addBtn.disabled = !variant.available;
      if (addBtn) addBtn.classList.toggle('btn--disabled', !variant.available);
      if (addText) addText.textContent = variant.available ? 'Aggiungi al Carrello' : 'Non Disponibile';
      if (buyNowBtn) buyNowBtn.disabled = !variant.available;

      if (variant.img_pos && pdpGoToSlide) {
        pdpGoToSlide(variant.img_pos - 1);
      }

      updateLowStock(String(variant.id));
    };

    // Cross-check which option values lead to available variants
    const optionBtns = variantSelector.querySelectorAll('.pdp__option-btn');
    const updateAvailability = () => {
      optionBtns.forEach(btn => {
        const pos = parseInt(btn.dataset.optionPosition);
        const val = btn.dataset.optionValue;
        const testOpts = { ...selectedOptions, [pos]: val };
        const hasMatch = allVariants.some(v =>
          v.options.every((opt, i) => testOpts[i + 1] === opt) && v.available
        );
        btn.classList.toggle('is-unavailable', !hasMatch);
      });
    };

    optionBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const position = parseInt(btn.dataset.optionPosition);
        const value = btn.dataset.optionValue;
        selectedOptions[position] = value;

        // Update active state within this group
        const group = btn.closest('.pdp__option-group');
        group.querySelectorAll('.pdp__option-btn').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        // Update label
        const label = group.querySelector('.pdp__option-selected');
        if (label) label.textContent = value;

        // Find + apply matching variant
        let variant = findVariant();

        if (!variant) {
          // Fallback: find any variant (preferably available) with the clicked value
          variant = allVariants.find(v => v.options[position - 1] === value && v.available) 
                 || allVariants.find(v => v.options[position - 1] === value);
                 
          if (variant) {
            // Update other options to match fallback
            variant.options.forEach((val, i) => {
              const pos = i + 1;
              if (pos === position) return; // Skip clicked one
              
              selectedOptions[pos] = val;
              const b = Array.from(optionBtns).find(btn => parseInt(btn.dataset.optionPosition) === pos && btn.dataset.optionValue === val);
              if (b) {
                const grp = b.closest('.pdp__option-group');
                grp.querySelectorAll('.pdp__option-btn').forEach(btn => btn.classList.remove('is-active'));
                b.classList.add('is-active');
                const lbl = grp.querySelector('.pdp__option-selected');
                if (lbl) lbl.textContent = val;
              }
            });
          }
        }

        if (variant) applyVariant(variant);

        updateAvailability();
      });
    });

    updateAvailability();

    // On load, show the pre-selected variant's image
    if (initVariant && initVariant.img_pos) {
      jumpGalleryTo(initVariant.img_pos - 1);
    }

    // Inject icons for quantity-type options (Singolo/Coppia)
    const gemSvg = '<svg class="pdp__option-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 2 10 12 22 22 10"/></svg>';
    const pairSvg = '<svg class="pdp__option-icon pdp__option-icon--pair" width="24" height="14" viewBox="0 0 38 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="10 2 2 10 10 22 18 10"/><polygon points="28 2 20 10 28 22 36 10"/></svg>';
    optionBtns.forEach(btn => {
      const text = btn.textContent.trim().toLowerCase();
      if (text === 'singolo') {
        btn.innerHTML = gemSvg + ' <span>Singolo</span>';
      } else if (text === 'coppia') {
        btn.innerHTML = pairSvg + ' <span>Coppia</span>';
      }
    });
  }

  /* ── Product Details Accordion ─────────────────────────── */
  const detailsTrigger = document.getElementById('details-trigger');
  const detailsContent = document.getElementById('details-content');
  if (detailsTrigger && detailsContent) {
    detailsTrigger.addEventListener('click', () => {
      const open = detailsContent.classList.toggle('is-open');
      detailsTrigger.classList.toggle('is-open', open);
    });
  }

  /* ── Sticky Add to Cart (mobile) ──────────────────────── */
  const stickyAtc = document.getElementById('sticky-atc');
  const addToCartForm = document.getElementById('add-to-cart-form');
  if (stickyAtc && addToCartForm) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '0px 0px 100px 0px' }
    );
    observer.observe(addToCartForm);

    // Sticky button triggers its own add-to-cart with animation
    const stickyBtn = document.getElementById('sticky-atc-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        // Trigger the main form submit which handles animation
        // (requestSubmit is missing on older iOS Safari / Chromium)
        if (typeof addToCartForm.requestSubmit === 'function') {
          addToCartForm.requestSubmit();
        } else {
          addToCartForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
        // Mirror animation on sticky button
        animateAtcButton(stickyBtn);
      });
    }
  }

  /* ── Revolut-style button animation helper ──────────── */
  function haptic(pattern) {
    if (navigator.vibrate) navigator.vibrate(pattern);
  }
  let chimeCtx = null; // reused — Chrome caps concurrent AudioContexts
  function playSuccessChime() {
    try {
      const ctx = chimeCtx = chimeCtx || new (window.AudioContext || window.webkitAudioContext)();
      if (ctx.state === 'suspended') ctx.resume();
      // Two-tone chime: C6 then E6
      [1047, 1319].forEach((freq, i) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.value = freq;
        gain.gain.setValueAtTime(0.12, ctx.currentTime + i * 0.12);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + i * 0.12 + 0.3);
        osc.connect(gain).connect(ctx.destination);
        osc.start(ctx.currentTime + i * 0.12);
        osc.stop(ctx.currentTime + i * 0.12 + 0.3);
      });
    } catch (e) { /* AudioContext not supported */ }
  }
  function animateAtcButton(btn) {
    if (!btn || btn.classList.contains('is-loading')) return;
    btn.classList.remove('is-success');
    btn.classList.add('is-loading');
    btn.disabled = true;
    haptic(10); // short tap on press
  }
  function animateAtcSuccess(btn) {
    if (!btn) return;
    btn.classList.remove('is-loading');
    btn.classList.add('is-success');
    haptic([15, 80, 15]); // double-tap confirmation
    playSuccessChime();
    setTimeout(() => {
      btn.classList.remove('is-success');
      btn.disabled = false;
    }, 2200);
  }
  function animateAtcError(btn) {
    if (!btn) return;
    btn.classList.remove('is-loading', 'is-success');
    btn.disabled = false;
    haptic([30, 50, 30, 50, 30]); // error buzz
  }

  /* ── AJAX Add to Cart ─────────────────────────────────── */
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(addToCartForm);
      const addBtn = document.getElementById('add-to-cart-btn');
      const stickyBtn = document.getElementById('sticky-atc-btn');

      // Start Revolut-style animation on main button
      animateAtcButton(addBtn);

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: parseInt(formData.get('quantity')) || 1,
          }),
        });

        if (!res.ok) throw new Error('Failed');

        // Update cart count
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const badge = document.getElementById('header-cart-count');
        const drawerCount = document.getElementById('cart-drawer-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = '';
        } else {
          // Create badge
          const cartIcon = document.getElementById('cart-toggle');
          if (cartIcon) {
            const span = document.createElement('span');
            span.className = 'header__badge';
            span.id = 'header-cart-count';
            span.textContent = cart.item_count;
            cartIcon.appendChild(span);
          }
        }
        if (drawerCount) drawerCount.textContent = cart.item_count;

        // Show success animation on both buttons
        animateAtcSuccess(addBtn);
        animateAtcSuccess(stickyBtn);

        // Refresh cart DOM contents in background
        requestBackgroundRefresh();

        // Open drawer after checkmark moment
        setTimeout(() => openCart(), 900);
      } catch (err) {
        animateAtcError(addBtn);
        animateAtcError(stickyBtn);
      }
    });
  }

  /* ── Buy Now (Add to Cart → Checkout) ─────────────────── */
  const buyNowBtn = document.getElementById('go-to-checkout-btn');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', async () => {
      const variantInput = document.getElementById('variant-id');
      if (!variantInput) return;

      const buyNowText = document.getElementById('buy-now-text');
      const originalText = buyNowText ? buyNowText.textContent : '';

      buyNowBtn.disabled = true;
      haptic(10);
      if (buyNowText) buyNowText.textContent = 'Un momento...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantInput.value,
            quantity: 1,
          }),
        });

        if (!res.ok) throw new Error('Failed');

        // Redirect straight to checkout
        haptic([15, 80, 15]);
        playSuccessChime();
        window.location.href = '/checkout';
      } catch (err) {
        if (buyNowText) buyNowText.textContent = 'Errore — riprova';
        setTimeout(() => {
          if (buyNowText) buyNowText.textContent = originalText;
          buyNowBtn.disabled = false;
        }, 2000);
      }
    });
  }

  /* ── Cart Item Actions (quantity, remove) ──────────────── */
  let cartBusy = false;
  let cartBusyTimeout = null;
  let bgRefreshRunning = false;
  let bgRefreshNeeded = false;

  function requestBackgroundRefresh() {
    bgRefreshNeeded = true;
    if (bgRefreshRunning) return; // current run will pick it up
    (async () => {
      bgRefreshRunning = true;
      while (bgRefreshNeeded) {
        bgRefreshNeeded = false;
        try { await refreshCartDrawer(); } catch (e) { console.warn('Background refresh failed', e); }
      }
      bgRefreshRunning = false;
    })();
  }

  function lockCart() {
    cartBusy = true;
    // Safety timeout: auto-unlock after 8 seconds to prevent permanent freeze
    if (cartBusyTimeout) clearTimeout(cartBusyTimeout);
    cartBusyTimeout = setTimeout(() => {
      cartBusy = false;
      cartBusyTimeout = null;
      console.warn('Cart busy timeout — auto-reset');
    }, 8000);
  }

  function unlockCart() {
    cartBusy = false;
    if (cartBusyTimeout) { clearTimeout(cartBusyTimeout); cartBusyTimeout = null; }
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-action]');
    if (!btn || cartBusy) return;

    const action = btn.dataset.action;
    const key = btn.dataset.key;
    lockCart();

    try {
      if (action === 'remove') {
        const keysAttr = btn.dataset.keys;
        if (keysAttr && keysAttr.includes(',')) {
          const keys = keysAttr.split(',');
          let updates = {};
          keys.forEach(k => updates[k] = 0);
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates }),
          });
        } else {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 }),
          });
        }
        // Animate out
        const item = btn.closest('.cart-item');
        if (item) {
          item.style.transition = 'opacity 0.3s, transform 0.3s';
          item.style.opacity = '0';
          item.style.transform = 'translateX(20px)';
          await new Promise(r => setTimeout(r, 300));
          item.remove();
        }
      }

      if (action === 'decrease') {
        const row = btn.closest('.cart-item');
        const qtyNum = row?.querySelector('.cart-item__qty-num');
        const displayedTotal = qtyNum ? parseInt(qtyNum.textContent) : 1;
        // Use per-key qty (data-main-qty) for the API call, NOT the merged displayed total
        const mainQty = btn.dataset.mainQty
          ? parseInt(btn.dataset.mainQty)
          : ((parseInt(btn.dataset.qty) || 0) + 1);
        let targetQty = Math.max(0, mainQty - 1);

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: targetQty }),
        });

        if (targetQty === 0 && displayedTotal <= 1) {
          // Last unit — remove the row visually
          const item = btn.closest('.cart-item');
          if (item) {
            item.style.transition = 'all 0.3s ease';
            item.style.opacity = '0';
            item.style.transform = 'translateX(20px)';
            await new Promise(r => setTimeout(r, 300));
            item.remove();
          }
        } else {
          // Optimistic: update displayed total and per-key tracking
          const newDisplayed = Math.max(0, displayedTotal - 1);
          if (qtyNum) qtyNum.textContent = newDisplayed;
          // Update per-key tracking for next click
          btn.dataset.mainQty = targetQty;
          btn.dataset.qty = Math.max(0, targetQty - 1);
          // Update increase button
          const incBtn = row?.querySelector('[data-action="increase"]');
          if (incBtn) incBtn.dataset.qty = newDisplayed + 1;
        }
      }

      if (action === 'increase') {
        const variantId = btn.dataset.variantId;
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] }),
        });

        if (!addRes.ok) {
          // Stock limit reached — shake + flash feedback
          const row = btn.closest('.cart-item');
          const qtyWrap = row?.querySelector('.cart-item__qty');
          if (qtyWrap) {
            qtyWrap.classList.add('cart-item__qty--shake');
            setTimeout(() => qtyWrap.classList.remove('cart-item__qty--shake'), 500);
          }
          btn.classList.add('cart-item__qty-btn--error');
          setTimeout(() => btn.classList.remove('cart-item__qty-btn--error'), 1200);
          // Show inline toast
          if (row && !row.querySelector('.cart-item__stock-toast')) {
            const toast = document.createElement('div');
            toast.className = 'cart-item__stock-toast';
            toast.textContent = 'Quantità massima raggiunta';
            row.querySelector('.cart-item__info')?.appendChild(toast);
            setTimeout(() => { toast.style.opacity = '0'; setTimeout(() => toast.remove(), 300); }, 2500);
          }
          haptic([30, 50, 30, 50, 30]);
          return; // Skip optimistic update + badge sync
        }

        // Optimistic: update displayed qty and data attrs immediately
        const row = btn.closest('.cart-item');
        const qtyNum = row?.querySelector('.cart-item__qty-num');
        const currentDisplayed = qtyNum ? parseInt(qtyNum.textContent) : 0;
        const newDisplayed = currentDisplayed + 1;
        if (qtyNum) qtyNum.textContent = newDisplayed;
        // Update decrease button per-key tracking
        const decBtn = row?.querySelector('[data-action="decrease"]');
        if (decBtn) {
          const decMainQty = parseInt(decBtn.dataset.mainQty || '0') + 1;
          decBtn.dataset.mainQty = decMainQty;
          decBtn.dataset.qty = decMainQty - 1;
        }
        btn.dataset.qty = newDisplayed + 1;
      }

      // Quick badge + subtotal sync from server (fast, 1 call)
      try {
        const cart = await (await fetch('/cart.js')).json();
        const badge = document.getElementById('header-cart-count');
        const drawerCount = document.getElementById('cart-drawer-count');
        const drawerTotal = document.getElementById('cart-drawer-total');
        if (badge) { badge.textContent = cart.item_count; badge.style.display = cart.item_count > 0 ? '' : 'none'; }
        if (drawerCount) drawerCount.textContent = cart.item_count;
        if (drawerTotal) drawerTotal.textContent = formatMoney(cart.total_price);
      } catch (e) { /* badge sync failed, background refresh will fix it */ }

    } catch (err) {
      console.warn('Cart action failed:', action, err);
    } finally {
      unlockCart();
    }
    // Full refresh runs in background — doesn't block next click
    requestBackgroundRefresh();
  });


  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* ── Cart Upsell Toggle ──────────────────────────────── */
  const upsellToggle = document.getElementById('upsell-toggle');
  if (upsellToggle) {
    upsellToggle.addEventListener('change', async () => {
      if (cartBusy) { upsellToggle.checked = !upsellToggle.checked; return; }
      const variantId = parseInt(upsellToggle.dataset.variantId);
      // Disable toggle while processing
      upsellToggle.disabled = true;
      lockCart();
      try {
        if (upsellToggle.checked) {
          // Add the upsell product
          const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          });
          if (!addRes.ok) throw new Error('Add failed: ' + addRes.status);
        } else {
          // First, fetch cart to find the line item key for this variant
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const lineItem = cart.items.find(item => item.variant_id === variantId);

          if (lineItem) {
            // Use the line item key (not variant ID) for reliable removal
            const changeRes = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: lineItem.key, quantity: 0 }),
            });
            if (!changeRes.ok) throw new Error('Remove failed: ' + changeRes.status);
          }
        }
      } catch (err) {
        // Revert toggle on failure
        upsellToggle.checked = !upsellToggle.checked;
        console.warn('Upsell toggle failed', err);
      } finally {
        upsellToggle.disabled = false;
        unlockCart();
      }
      // Refresh in background
      requestBackgroundRefresh();
    });
  }

  /* ── Discount Code ───────────────────────────────────── */
  const discountInput = document.getElementById('cart-discount-input');
  const discountApplyBtn = document.getElementById('cart-discount-apply');
  const discountMsg = document.getElementById('cart-discount-msg');
  let appliedDiscount = '';

  function showDiscountMsg(text, type) {
    if (!discountMsg) return;
    discountMsg.className = 'cart-drawer__discount-msg cart-drawer__discount-msg--' + type;
    discountMsg.innerHTML = text;
    // Visual error on input wrapper
    const inputWrap = document.querySelector('.cart-drawer__discount-input-wrap');
    if (inputWrap) {
      if (type === 'error') {
        inputWrap.classList.remove('has-error');
        void inputWrap.offsetHeight; // force reflow for re-triggering animation
        inputWrap.classList.add('has-error');
        setTimeout(() => inputWrap.classList.remove('has-error'), 3000);
      } else {
        inputWrap.classList.remove('has-error');
      }
    }
  }

  function showAppliedBadge(code) {
    if (!discountMsg) return;
    discountMsg.className = 'cart-drawer__discount-msg cart-drawer__discount-msg--applied';
    discountMsg.innerHTML = `
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>
      <span>${code}</span>
      <button class="cart-drawer__discount-remove" aria-label="Rimuovi sconto" type="button">✕</button>
    `;
    // Hide the input row when a code is applied
    const row = document.querySelector('.cart-drawer__discount-row');
    if (row) row.style.display = 'none';
    // Wire remove button
    const removeBtn = discountMsg.querySelector('.cart-drawer__discount-remove');
    if (removeBtn) {
      removeBtn.addEventListener('click', async () => {
        appliedDiscount = '';
        discountMsg.className = 'cart-drawer__discount-msg';
        discountMsg.innerHTML = '';
        if (row) row.style.display = '';
        if (discountInput) { discountInput.value = ''; discountInput.focus(); }
        // Reset checkout URL
        const checkoutLink = document.getElementById('cart-checkout-link');
        if (checkoutLink) checkoutLink.href = '/checkout';
        // Clear the Shopify discount session and update subtotal
        try {
          await fetch('/discount/', { method: 'GET', redirect: 'follow' });
          await new Promise(r => setTimeout(r, 300));
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const totalEl = document.getElementById('cart-drawer-total');
          if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
          // Also refresh cart items to remove discount labels
          requestBackgroundRefresh();
        } catch(e) { /* silent */ }
      });
    }
  }

  if (discountApplyBtn && discountInput) {
    async function applyDiscount() {
      const code = discountInput.value.trim();
      if (!code) {
        showDiscountMsg('Inserisci un codice sconto', 'error');
        discountInput.focus();
        return;
      }

      discountApplyBtn.disabled = true;
      discountApplyBtn.textContent = '...';

      try {
        // Get cart state BEFORE applying discount
        const beforeRes = await fetch('/cart.js');
        const beforeCart = await beforeRes.json();
        const beforeDiscount = beforeCart.total_discount || 0;
        const beforeCodes = (beforeCart.cart_level_discount_applications || []).map(d => d.title.toUpperCase());

        // Shopify applies discount via /discount/CODE — sets a session cookie
        await fetch('/discount/' + encodeURIComponent(code), {
          method: 'GET',
          redirect: 'follow'
        });

        // Small delay for Shopify to process
        await new Promise(r => setTimeout(r, 300));

        // Get cart state AFTER applying discount
        const afterRes = await fetch('/cart.js');
        const afterCart = await afterRes.json();
        const afterDiscount = afterCart.total_discount || 0;
        const afterCodes = (afterCart.cart_level_discount_applications || []).map(d => d.title.toUpperCase());

        // Check if discount was actually applied
        const codeUpper = code.toUpperCase();
        const hasNewDiscount = afterDiscount > beforeDiscount;
        const hasNewCode = afterCodes.includes(codeUpper) && !beforeCodes.includes(codeUpper);
        // Also check line-level discounts
        const hasLineDiscount = afterCart.items.some(item => 
          item.line_level_discount_allocations && 
          item.line_level_discount_allocations.some(d => 
            d.discount_application && d.discount_application.title.toUpperCase() === codeUpper
          )
        );

        if (hasNewDiscount || hasNewCode || hasLineDiscount) {
          appliedDiscount = codeUpper;
          showAppliedBadge(appliedDiscount);
          // Update checkout link to include discount
          const checkoutLink = document.getElementById('cart-checkout-link');
          if (checkoutLink) {
            checkoutLink.href = '/checkout?discount=' + encodeURIComponent(appliedDiscount);
          }
          // Update totals if discount changed
          if (afterDiscount !== beforeDiscount) {
            const totalEl = document.getElementById('cart-drawer-total');
            if (totalEl) totalEl.textContent = formatMoney(afterCart.total_price);
          }
          haptic && haptic([10, 60, 10]);
        } else {
          // Discount code was not recognized — clear the session cookie
          await fetch('/discount/', { method: 'GET', redirect: 'follow' });
          showDiscountMsg('Codice non valido o non applicabile', 'error');
          haptic && haptic([30, 50, 30]);
        }
      } catch (err) {
        showDiscountMsg('Errore — riprova', 'error');
      } finally {
        discountApplyBtn.disabled = false;
        discountApplyBtn.textContent = 'Applica';
      }
    }

    discountApplyBtn.addEventListener('click', applyDiscount);
    discountInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); applyDiscount(); }
    });
  }

  /* ── Order Notes (collapsible + auto-save) ────────────── */
  const notesToggle = document.getElementById('cart-notes-toggle');
  const notesBody = document.getElementById('cart-notes-body');
  const noteInput = document.getElementById('cart-note-input');
  const noteStatus = document.getElementById('cart-note-status');
  let noteSaveTimer = null;

  if (notesToggle && notesBody) {
    // Auto-open if there's already a note
    if (noteInput && noteInput.value.trim()) {
      notesBody.classList.add('is-open');
      notesToggle.setAttribute('aria-expanded', 'true');
    }

    notesToggle.addEventListener('click', () => {
      const isOpen = notesBody.classList.contains('is-open');
      notesBody.classList.toggle('is-open', !isOpen);
      notesToggle.setAttribute('aria-expanded', String(!isOpen));
      if (!isOpen && noteInput) setTimeout(() => noteInput.focus(), 200);
    });
  }

  if (noteInput) {
    noteInput.addEventListener('input', () => {
      if (noteSaveTimer) clearTimeout(noteSaveTimer);
      if (noteStatus) { noteStatus.textContent = ''; noteStatus.style.opacity = '0'; }
      noteSaveTimer = setTimeout(async () => {
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: noteInput.value })
          });
          if (noteStatus) {
            noteStatus.textContent = '✓ Nota salvata';
            noteStatus.style.opacity = '1';
            setTimeout(() => { noteStatus.style.opacity = '0'; }, 2000);
          }
        } catch (e) {
          if (noteStatus) {
            noteStatus.textContent = 'Errore nel salvataggio';
            noteStatus.style.opacity = '1';
          }
        }
      }, 800);
    });
  }

  async function syncRewardGifts(cart) {
    if (!window.AtlantideRewards) return false;

    // Collect all enabled gift variant IDs
    const allGiftVariantIds = [];
    [window.AtlantideRewards.tier1, window.AtlantideRewards.tier2, window.AtlantideRewards.tier3].forEach(tier => {
      if (tier && tier.enabled && tier.giftVariantId) {
        allGiftVariantIds.push(parseInt(tier.giftVariantId));
      }
    });

    // Calculate subtotal excluding gift variant items (gifts shouldn't unlock more gifts)
    let subtotalCents = 0;
    cart.items.forEach(item => {
      if (!allGiftVariantIds.includes(item.variant_id)) {
        subtotalCents += item.final_line_price;
      }
    });

    const subtotalEuros = subtotalCents / 100;
    const itemsToAdd = [];
    const keysToRemove = [];
    let needsUpdate = false;

    [window.AtlantideRewards.tier1, window.AtlantideRewards.tier2, window.AtlantideRewards.tier3].forEach(tier => {
      if (tier.enabled && tier.giftVariantId) {
        const giftVariantId = parseInt(tier.giftVariantId);
        // Find ANY existing item with this variant (regardless of properties)
        const existingGift = cart.items.find(item => item.variant_id === giftVariantId);

        if (subtotalEuros >= tier.threshold) {
          if (!existingGift) {
            // Add WITHOUT properties so Shopify automatic discount can match it
            itemsToAdd.push({
              id: giftVariantId,
              quantity: 1
            });
            try { localStorage.setItem('atlantide_auto_gift_' + giftVariantId, '1'); } catch(e) {}
            needsUpdate = true;
          }
          // If already in cart (manual or auto), leave it — Shopify discount handles pricing
        } else {
          if (existingGift) {
            // Only auto-remove if WE added it (not manually added by customer)
            let weAdded = false;
            try { weAdded = !!localStorage.getItem('atlantide_auto_gift_' + giftVariantId); } catch(e) {}
            if (weAdded) {
              keysToRemove.push(existingGift.key);
              try { localStorage.removeItem('atlantide_auto_gift_' + giftVariantId); } catch(e) {}
              needsUpdate = true;
            }
          }
        }
      }
    });

    if (needsUpdate) {
      try {
        if (keysToRemove.length > 0) {
          const updates = {};
          keysToRemove.forEach(key => updates[key] = 0);
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
        }
        if (itemsToAdd.length > 0) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: itemsToAdd })
          });
        }
        return true;
      } catch (e) {
        console.warn('Sync reward gifts failed', e);
      }
    }
    return false;
  }

  /**
   * Refresh the cart drawer contents in-place using /cart.js JSON data.
   * Rebuilds cart item cards, updates totals, badge, count, and upsell toggle state.
   */
  async function refreshCartDrawer() {
    try {
      let cartRes = await fetch('/cart.js');
      let cart = await cartRes.json();

      const giftsChanged = await syncRewardGifts(cart);
      if (giftsChanged) {
        cartRes = await fetch('/cart.js');
        cart = await cartRes.json();
      }

      // Check if the only remaining item is an upsell...
      const toggle = document.getElementById('upsell-toggle');
      if (toggle && cart.items.length === 1) {
        const upsellVariantId = parseInt(toggle.dataset.variantId);
        if (cart.items[0].variant_id === upsellVariantId) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: cart.items[0].key, quantity: 0 })
          });
          // Re-run once (with guard to prevent infinite recursion)
          if (!refreshCartDrawer._recursing) {
            refreshCartDrawer._recursing = true;
            try { return await refreshCartDrawer(); } finally { refreshCartDrawer._recursing = false; }
          }
        }
      }

      // Update header badge + drawer count + total
      const badge = document.getElementById('header-cart-count');
      const drawerCount = document.getElementById('cart-drawer-count');
      const drawerTotal = document.getElementById('cart-drawer-total');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? '' : 'none';
      }
      if (drawerCount) drawerCount.textContent = cart.item_count;
      if (drawerTotal) drawerTotal.textContent = formatMoney(cart.total_price);

      const drawerFooter = document.getElementById('cart-drawer-footer') || document.querySelector('.cart-drawer__footer');
      if (drawerFooter) drawerFooter.style.display = cart.item_count > 0 ? '' : 'none';

      // Hide reward bar + upsell + notes when cart is empty
      const topAddons = document.getElementById('cart-drawer-top-addons');
      if (topAddons) topAddons.style.display = cart.item_count > 0 ? '' : 'none';
      const bottomAddons = document.getElementById('cart-drawer-addons');
      if (bottomAddons) bottomAddons.style.display = cart.item_count > 0 ? '' : 'none';
      const notesWrap = document.getElementById('cart-drawer-notes');
      if (notesWrap) notesWrap.style.display = cart.item_count > 0 ? '' : 'none';

      const itemsContainer = document.getElementById('cart-items-container');
      const emptyContainer = document.getElementById('cart-empty-container');

      if (itemsContainer) itemsContainer.style.display = cart.item_count > 0 ? '' : 'none';
      if (emptyContainer) emptyContainer.style.display = cart.item_count > 0 ? 'none' : '';

      // Refresh "You may also like" recommendations
      loadCartRecommendations(cart);

      if (cart.items.length > 0 && itemsContainer) {
        let itemsHtml = '';
        


        // Build gift variant ID list for identifying gift items
        const giftVariantIds = [];
        if (window.AtlantideRewards) {
          [window.AtlantideRewards.tier1, window.AtlantideRewards.tier2, window.AtlantideRewards.tier3].forEach(tier => {
            if (tier && tier.enabled && tier.giftVariantId) giftVariantIds.push(parseInt(tier.giftVariantId));
          });
        }

        let mergedItems = [];
        cart.items.forEach(item => {
          const isDiscounted = item.original_line_price > item.final_line_price;
          // Gift = variant matches a gift variant (€0 variant = inherently free)
          const isGift = giftVariantIds.includes(item.variant_id);
          
          let existing = mergedItems.find(m => 
            m.variant_id === item.variant_id && 
            !!m._isGift === !!isGift && 
            m._isDiscounted === isDiscounted &&
            (!isDiscounted || m.final_price === item.final_price)
          );

          if (existing) {
            existing.quantity += item.quantity;
            existing.final_line_price += item.final_line_price;
            existing.original_line_price += item.original_line_price;
            existing._keys.push({ key: item.key, qty: item.quantity });
            if (item.line_level_discount_allocations) {
              item.line_level_discount_allocations.forEach(d => {
                if (d.amount > 0) existing.line_level_discount_allocations.push(d);
              });
            }
          } else {
            let clone = JSON.parse(JSON.stringify(item));
            clone._isGift = isGift;
            clone._isDiscounted = isDiscounted;
            clone._keys = [{ key: item.key, qty: item.quantity }];
            if (clone.line_level_discount_allocations) {
              clone.line_level_discount_allocations = clone.line_level_discount_allocations.filter(d => d.amount > 0);
            }
            mergedItems.push(clone);
          }
        });

        mergedItems.forEach(item => {
          const imgSrc = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_160x160_crop_center$1$2') : '';
          const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
            ? `<span class="cart-item__variant">${item.variant_title}</span>` : '';
          
          const isGift = item._isGift;
          let classStr = "cart-item";
          if (isGift) classStr += " cart-item--gift";

          let discountsHtml = '';
          if (!isGift && item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
            const seenTitles = new Set();
            let labels = '';
            item.line_level_discount_allocations.forEach(discount => {
              const title = discount.discount_application.title;
              if (discount.amount > 0 && !seenTitles.has(title)) {
                seenTitles.add(title);
                labels += `<span class="cart-item__discount-label">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:4px;"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
                  ${title}
                </span>`;
              }
            });
            if (labels) discountsHtml = '<div class="cart-item__discounts">' + labels + '</div>';
          }

          let priceHtml = '';
          if (isGift) {
            priceHtml = `<span class="cart-item__price cart-item__price--gift">OMAGGIO</span>`;
          } else {
            priceHtml = `<div class="cart-item__price-wrapper">`;
            if (item.original_line_price > item.final_line_price) {
              priceHtml += `<s class="cart-item__old-price" style="opacity:0.6; font-size:0.8em; margin-right:4px;">${formatMoney(item.original_line_price)}</s>`;
            }
            priceHtml += `<span class="cart-item__price">${formatMoney(item.final_line_price)}</span></div>`;
          }

          const mainKey = item._keys[0].key;
          const mainQty = item._keys[0].qty;
          const allKeys = item._keys.map(k => k.key).join(',');

          itemsHtml += `
            <div class="${classStr}" data-line-id="${mainKey}" data-product-id="${item.product_id}">
              ${imgSrc ? `<div class="cart-item__image-wrap"><img class="cart-item__image" src="${imgSrc}" alt="${item.title}" loading="lazy" width="80" height="80"></div>` : ''}
              <div class="cart-item__info">
                <a href="${item.url}" class="cart-item__name">${item.product_title}</a>${variantTitle}
                ${discountsHtml}
                ${priceHtml}
              </div>
              <div class="cart-item__actions">
                ${isGift ? `<span class="cart-item__gift-badge"><img src="${window.AtlantideRewards?.giftIconUrl || ''}" alt="Omaggio" width="32" height="32"></span>` : `
                <button class="cart-item__remove" data-action="remove" data-keys="${allKeys}" data-key="${mainKey}" aria-label="Rimuovi">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>
                </button>
                <div class="cart-item__qty">
                  <button class="cart-item__qty-btn" data-action="decrease" data-key="${mainKey}" data-main-qty="${mainQty}" data-qty="${mainQty - 1}" aria-label="−">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg>
                  </button>
                  <span class="cart-item__qty-num">${item.quantity}</span>
                  <button class="cart-item__qty-btn" data-action="increase" data-variant-id="${item.variant_id}" data-key="${mainKey}" data-qty="${mainQty + 1}" aria-label="+">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                  </button>
                </div>
                `}
              </div>
            </div>`;
        });
        itemsContainer.innerHTML = itemsHtml;
      }

      // Sync the upsell toggle checked state
      const checkboxToggle = document.getElementById('upsell-toggle');
      if (checkboxToggle) {
        const upsellVariantId = parseInt(checkboxToggle.dataset.variantId);
        const isInCart = cart.items.some(item => item.variant_id === upsellVariantId);
        checkboxToggle.checked = isInCart;
      }

    } catch (err) {
      console.warn('Cart drawer refresh failed', err);
    }

    // Deferred: update reward bar from section HTML (non-blocking, ~400ms saved)
    setTimeout(async () => {
      try {
        const htmlRes = await fetch('/?section_id=cart-content');
        const htmlText = await htmlRes.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        const newRewardBar = doc.querySelector('.reward-bar');
        
        if (newRewardBar) {
          document.querySelectorAll('.reward-bar').forEach(bar => {
            const newMsg = newRewardBar.querySelector('.reward-bar__message');
            const oldMsg = bar.querySelector('.reward-bar__message');
            if (newMsg && oldMsg) oldMsg.innerHTML = newMsg.innerHTML;

            const newFill = newRewardBar.querySelector('.reward-bar__fill');
            const oldFill = bar.querySelector('.reward-bar__fill');
            if (newFill && oldFill) {
              oldFill.style.width = newFill.style.width;
              // Sync shimmer animation state
              if (newFill.classList.contains('is-complete')) {
                oldFill.classList.add('is-complete');
              } else {
                oldFill.classList.remove('is-complete');
              }
            }

            const newMarkers = newRewardBar.querySelectorAll('.reward-bar__marker');
            const oldMarkers = bar.querySelectorAll('.reward-bar__marker');
            newMarkers.forEach((nm, idx) => {
              if (oldMarkers[idx]) {
                const wasUnlocked = oldMarkers[idx].classList.contains('is-unlocked');
                const isUnlockedNow = nm.classList.contains('is-unlocked');
                if (!wasUnlocked && isUnlockedNow) {
                  oldMarkers[idx].classList.add('is-unlocked');
                  oldMarkers[idx].style.animation = 'none';
                  oldMarkers[idx].offsetHeight;
                  oldMarkers[idx].style.animation = 'unlock-pop 0.6s var(--ease-spring) forwards';
                } else if (wasUnlocked && !isUnlockedNow) {
                  oldMarkers[idx].classList.remove('is-unlocked');
                  oldMarkers[idx].style.animation = 'none';
                }
              }
            });

            const newLabels = newRewardBar.querySelectorAll('.reward-bar__label');
            const oldLabels = bar.querySelectorAll('.reward-bar__label');
            newLabels.forEach((nl, idx) => {
              if (oldLabels[idx]) {
                if (nl.classList.contains('is-unlocked')) oldLabels[idx].classList.add('is-unlocked');
                else oldLabels[idx].classList.remove('is-unlocked');
                oldLabels[idx].innerHTML = nl.innerHTML;
              }
            });
          });
        }
      } catch(e) {
        console.warn('Could not update reward bar HTML dynamically', e);
      }
    }, 0);
  }

  /* ── Cart Recommendations ("You may also like") ──────── */
  let _lastRecsProductId = null;

  function loadCartRecommendations(cart) {
    const recsContainer = document.getElementById('cart-recommendations');
    if (!recsContainer) return;

    // Hide when cart is empty
    if (!cart || cart.items.length === 0) {
      recsContainer.style.display = 'none';
      _lastRecsProductId = null;
      return;
    }

    // Find first non-gift product for recommendations
    const recGiftIds = [];
    if (window.AtlantideRewards) {
      [window.AtlantideRewards.tier1, window.AtlantideRewards.tier2, window.AtlantideRewards.tier3].forEach(tier => {
        if (tier && tier.enabled && tier.giftVariantId) recGiftIds.push(parseInt(tier.giftVariantId));
      });
    }
    const firstProduct = cart.items.find(item => !recGiftIds.includes(item.variant_id));
    if (!firstProduct) {
      recsContainer.style.display = 'none';
      _lastRecsProductId = null;
      return;
    }

    const productId = firstProduct.product_id;

    // Skip if we already loaded recs for this product
    if (_lastRecsProductId === productId) {
      recsContainer.style.display = '';
      return;
    }

    fetch(`/recommendations/products.json?product_id=${productId}&limit=6&intent=related`)
      .then(r => r.json())
      .then(data => {
        const products = data.products || [];
        if (products.length === 0) {
          recsContainer.style.display = 'none';
          return;
        }
        _lastRecsProductId = productId;
        const html = products.slice(0, 8).map(p => {
          const img = p.featured_image ? `<img src="${p.featured_image}" alt="${p.title}" style="width: 100%; height: 100%; object-fit: cover; display: block;" loading="lazy">` : '';
          const price = formatMoney(p.price);
          
          const variantId = p.variants && p.variants.length > 0 ? p.variants[0].id : null;
          const hasMultipleVariants = p.variants && p.variants.length > 1;
          const atcBtn = variantId 
            ? `<button class="product-card__atc" data-variant-id="${variantId}" data-product-handle="${p.handle}" data-variant-count="${p.variants.length}" aria-label="Aggiungi al carrello" style="position: absolute; bottom: 8px; right: 8px; background: rgba(255,255,255,0.9); border: 1px solid rgba(0,0,0,0.1); border-radius: 50%; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; cursor: pointer; box-shadow: 0 2px 8px rgba(0,0,0,0.1); color: var(--color-text); z-index: 2; transition: all 0.2s ease;">
                 <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
               </button>`
            : '';

          return `
            <div class="cart-rec__item" style="flex: 0 0 140px; scroll-snap-align: start; position: relative;">
              <div style="position: relative; margin-bottom: 8px;">
                <a href="${p.url}" class="cart-rec__image-link" style="display: block; background: #f4f4f4; border-radius: 8px; overflow: hidden; aspect-ratio: 1;">
                  ${img}
                </a>
                ${atcBtn}
              </div>
              <a href="${p.url}" style="text-decoration: none; display: block;">
                <span class="cart-rec__name" style="font-size: 0.8rem; font-weight: 600; color: var(--color-text); line-height: 1.2; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">${p.title}</span>
                <span class="cart-rec__price" style="font-size: 0.8rem; color: var(--color-text-secondary); margin-top: 4px; display: block;">${price}</span>
              </a>
            </div>`;
        }).join('');
        const grid = recsContainer.querySelector('.cart-rec__grid');
        if (grid) {
          grid.innerHTML = html;
          initDraggableSlider(grid);
        }
        recsContainer.style.display = '';
      })
      .catch(() => {
        recsContainer.style.display = 'none';
      });
  }

  // Initial load (if cart has items on page load)
  (async () => {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      if (cart.items.length > 0) loadCartRecommendations(cart);
    } catch (e) { /* silent */ }
  })();

  /* ── Scroll Reveal Animations (Repeatable) ─────────────── */
  const revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
            } else {
              // Remove class so it animates again when scrolling back
              entry.target.classList.remove('is-visible');
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
      )
    : null;

  function observeReveals(root) {
    const els = (root || document).querySelectorAll('.reveal, .reveal-stagger');
    if (revealObserver) {
      els.forEach((el) => revealObserver.observe(el));
    } else {
      els.forEach((el) => el.classList.add('is-visible'));
    }
  }
  observeReveals();

  /* Shopify Theme Editor — re-init on section render */
  document.addEventListener('shopify:section:load', (e) => {
    observeReveals(e.target);
    // Re-init Shop the Look if it was re-rendered
    initShopTheLook();
  });
  document.addEventListener('shopify:section:select', (e) => {
    observeReveals(e.target);
  });
  document.addEventListener('shopify:block:select', (e) => {
    observeReveals(e.target.closest('.shopify-section'));
  });

  /* ── Parallax Hero ─────────────────────────────────────── */
  const heroImage = document.querySelector('.hero__image');
  if (heroImage) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y < window.innerHeight) {
        heroImage.style.transform = `scale(${1 + y * 0.0002}) translateY(${y * 0.3}px)`;
      }
    }, { passive: true });
  }

  /* ── FAQ Accordion ───────────────────────────────────── */
  document.querySelectorAll('[data-faq-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.faq-item');
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';

      // Close all other items
      document.querySelectorAll('.faq-item.is-open').forEach((openItem) => {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          openItem.querySelector('[data-faq-trigger]').setAttribute('aria-expanded', 'false');
        }
      });

      // Toggle current
      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  /* ── Gallery Keyboard Navigation ──────────────────────── */
  if (galleryTrack) {
    const galleryContainer = galleryTrack.closest('.pdp__gallery');
    if (galleryContainer) {
      galleryContainer.setAttribute('tabindex', '0');
      galleryContainer.setAttribute('role', 'region');
      galleryContainer.setAttribute('aria-label', 'Galleria immagini prodotto');

      galleryContainer.addEventListener('keydown', (e) => {
        const slides = galleryTrack.querySelectorAll('.pdp__slide');
        const dots = document.querySelectorAll('.pdp__dot');
        let current = 0;
        dots.forEach((d, i) => { if (d.classList.contains('is-active')) current = i; });

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          const next = Math.min(current + 1, slides.length - 1);
          // Reuse goToSlide via simulated dot click
          if (dots[next]) dots[next].click();
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          const prev = Math.max(current - 1, 0);
          if (dots[prev]) dots[prev].click();
        }
      });
    }
  }

  /* ── Focus Trapping ──────────────────────────────────── */
  function trapFocus(container) {
    // Query on every keydown: the cart drawer's contents are re-rendered on
    // each cart change, so nodes cached at load would be detached and the
    // trap would silently stop working.
    container.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const focusable = container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  // Apply focus trapping to overlays
  if (cartDrawer) {
    trapFocus(cartDrawer);
    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) {
        closeCart();
        if (cartToggle) cartToggle.focus();
      }
    });
  }

  if (mobileMenu) {
    trapFocus(mobileMenu);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
        closeMenu();
        if (menuToggle) menuToggle.focus();
      }
    });
  }

  /* ── Back to Top Button ──────────────────────────────── */
  const backToTopBtn = document.createElement('button');
  backToTopBtn.className = 'back-to-top';
  backToTopBtn.setAttribute('aria-label', 'Torna su');
  backToTopBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="18 15 12 9 6 15"/></svg>';
  document.body.appendChild(backToTopBtn);

  window.addEventListener('scroll', () => {
    backToTopBtn.classList.toggle('is-visible', window.scrollY > 600);
  }, { passive: true });

  backToTopBtn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* ── Variant Picker Bottom Sheet ─────────────────────── */
  const variantSheet = document.getElementById('variant-sheet');
  const variantBackdrop = document.getElementById('variant-sheet-backdrop');
  const variantSheetClose = document.getElementById('variant-sheet-close');
  const variantSheetImage = document.getElementById('variant-sheet-image');
  const variantSheetTitle = document.getElementById('variant-sheet-title');
  const variantSheetPrice = document.getElementById('variant-sheet-price');
  const variantSheetOptions = document.getElementById('variant-sheet-options');
  const variantSheetAtc = document.getElementById('variant-sheet-atc');

  let _sheetProductData = null;
  let _sheetSelectedVariant = null;
  let _sheetOriginBtn = null;

  function openVariantSheet() {
    if (variantBackdrop) variantBackdrop.classList.add('is-open');
    if (variantSheet) variantSheet.classList.add('is-open');
  }

  function closeVariantSheet() {
    if (variantBackdrop) variantBackdrop.classList.remove('is-open');
    if (variantSheet) variantSheet.classList.remove('is-open');
    _sheetProductData = null;
    _sheetSelectedVariant = null;
    _sheetOriginBtn = null;
  }

  if (variantBackdrop) variantBackdrop.addEventListener('click', closeVariantSheet);
  if (variantSheetClose) variantSheetClose.addEventListener('click', closeVariantSheet);

  function renderVariantSheet(product) {
    // Hide the internal "Omaggio" (gift) variant, like the product page does
    const realVariants = product.variants.filter(v => v.title !== 'Omaggio');
    if (realVariants.length) product = { ...product, variants: realVariants };
    _sheetProductData = product;
    const firstAvailable = product.variants.find(v => v.available) || product.variants[0];
    _sheetSelectedVariant = firstAvailable;

    // Product image
    const getImgSrc = (variant, product) => {
      if (variant.featured_image) {
        return typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src;
      }
      return typeof product.featured_image === 'string' ? product.featured_image : (product.featured_image ? product.featured_image.src : null);
    };
    const imgSrc = getImgSrc(firstAvailable, product);
    if (variantSheetImage) {
      variantSheetImage.innerHTML = imgSrc ? `<img src="${imgSrc}" alt="${product.title}">` : '';
    }

    // Title & price
    if (variantSheetTitle) variantSheetTitle.textContent = product.title;
    if (variantSheetPrice) variantSheetPrice.textContent = formatMoney(firstAvailable.price);

    // Build option groups
    if (variantSheetOptions && product.options && product.options.length > 0) {
      // Skip rendering if only "Default Title"
      if (product.options.length === 1 && product.variants.length === 1 && product.variants[0].title === 'Default Title') {
        variantSheetOptions.innerHTML = '';
      } else {
        let optionsHTML = '';
        product.options.forEach((opt, optIdx) => {
          // opt can be a string or an object {name, position, values}
          const optName = typeof opt === 'string' ? opt : (opt.name || opt);
          
          // Collect unique values for this option
          const values = [];
          if (typeof opt === 'object' && opt.values) {
            // Use values directly from option definition
            opt.values.forEach(val => { if (val !== 'Omaggio' && !values.includes(val)) values.push(val); });
          } else {
            // Fallback: extract from variants
            product.variants.forEach(v => {
              const val = optIdx === 0 ? v.option1 : optIdx === 1 ? v.option2 : v.option3;
              if (val && !values.includes(val)) values.push(val);
            });
          }

          const selectedVal = optIdx === 0 ? firstAvailable.option1 : optIdx === 1 ? firstAvailable.option2 : firstAvailable.option3;

          optionsHTML += `
            <div class="variant-sheet__option-group" data-option-index="${optIdx}">
              <span class="variant-sheet__option-label">${optName}: <strong id="variant-sheet-opt-val-${optIdx}">${selectedVal}</strong></span>
              <div class="variant-sheet__option-chips">
                ${values.map(val => {
                  const isSelected = val === selectedVal;
                  const isAvailable = product.variants.some(v => {
                    const vVal = optIdx === 0 ? v.option1 : optIdx === 1 ? v.option2 : v.option3;
                    return vVal === val && v.available;
                  });
                  // Singolo/Coppia icons
                  const lc = val.toLowerCase();
                  const gemSvg = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 2 10 12 22 22 10"/></svg>';
                  const pairSvg = '<svg width="24" height="14" viewBox="0 0 38 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="10 2 2 10 10 22 18 10"/><polygon points="28 2 20 10 28 22 36 10"/></svg>';
                  let chipContent = val;
                  if (lc === 'singolo') chipContent = gemSvg + ' ' + val;
                  else if (lc === 'coppia') chipContent = pairSvg + ' ' + val;
                  return `<button class="variant-sheet__chip${isSelected ? ' is-selected' : ''}${!isAvailable ? ' is-unavailable' : ''}" 
                    data-option-index="${optIdx}" data-value="${val}">${chipContent}</button>`;
                }).join('')}
              </div>
            </div>`;
        });
        variantSheetOptions.innerHTML = optionsHTML;
      }
    }

    // Enable/disable ATC
    updateSheetAtcState();
    openVariantSheet();
  }

  function updateSheetAtcState() {
    if (!variantSheetAtc) return;
    
    const cartIcon = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-3px;margin-right:6px"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>';

    if (_sheetSelectedVariant && _sheetSelectedVariant.available) {
      variantSheetAtc.disabled = false;
      variantSheetAtc.innerHTML = cartIcon + 'Aggiungi al carrello';
    } else {
      variantSheetAtc.disabled = true;
      variantSheetAtc.innerHTML = 'Non disponibile';
    }
  }

  function findMatchingVariant(product, selectedOptions) {
    return product.variants.find(v => {
      return product.options.every((_, idx) => {
        const vVal = idx === 0 ? v.option1 : idx === 1 ? v.option2 : v.option3;
        return vVal === selectedOptions[idx];
      });
    });
  }

  // Handle chip clicks
  if (variantSheetOptions) {
    variantSheetOptions.addEventListener('click', (e) => {
      const chip = e.target.closest('.variant-sheet__chip');
      if (!chip || !_sheetProductData) return;

      const optIdx = parseInt(chip.dataset.optionIndex);
      const value = chip.dataset.value;

      // Update selected chips in this group
      const group = chip.closest('.variant-sheet__option-group');
      group.querySelectorAll('.variant-sheet__chip').forEach(c => c.classList.remove('is-selected'));
      chip.classList.add('is-selected');

      // Update label
      const label = document.getElementById(`variant-sheet-opt-val-${optIdx}`);
      if (label) label.textContent = value;

      // Build current selection array
      const selectedOptions = [];
      variantSheetOptions.querySelectorAll('.variant-sheet__option-group').forEach(g => {
        const sel = g.querySelector('.variant-sheet__chip.is-selected');
        selectedOptions.push(sel ? sel.dataset.value : '');
      });

      // Find matching variant
      let matchedVariant = findMatchingVariant(_sheetProductData, selectedOptions);

      if (!matchedVariant) {
        // Fallback: finding alternative variant holding the clicked option
        matchedVariant = _sheetProductData.variants.find(v => {
          const vVal = optIdx === 0 ? v.option1 : optIdx === 1 ? v.option2 : v.option3;
          return vVal === value && v.available;
        }) || _sheetProductData.variants.find(v => {
          const vVal = optIdx === 0 ? v.option1 : optIdx === 1 ? v.option2 : v.option3;
          return vVal === value;
        });

        if (matchedVariant) {
          _sheetProductData.options.forEach((opt, idx) => {
            if (idx === optIdx) return;
            const targetVal = idx === 0 ? matchedVariant.option1 : idx === 1 ? matchedVariant.option2 : matchedVariant.option3;
            const optionGroup = variantSheetOptions.querySelector(`.variant-sheet__option-group[data-option-index="${idx}"]`);
            if (optionGroup) {
              optionGroup.querySelectorAll('.variant-sheet__chip').forEach(c => {
                c.classList.toggle('is-selected', c.dataset.value === targetVal);
              });
              const lbl = document.getElementById(`variant-sheet-opt-val-${idx}`);
              if (lbl) lbl.textContent = targetVal;
            }
          });
        }
      }

      if (matchedVariant) {
        _sheetSelectedVariant = matchedVariant;

        // Update price
        if (variantSheetPrice) variantSheetPrice.textContent = formatMoney(matchedVariant.price);

        // Update image if variant has its own image
        const varImgSrc = (() => {
          if (matchedVariant.featured_image) {
            return typeof matchedVariant.featured_image === 'string' ? matchedVariant.featured_image : matchedVariant.featured_image.src;
          }
          const fi = _sheetProductData.featured_image;
          return typeof fi === 'string' ? fi : (fi ? fi.src : null);
        })();
        if (variantSheetImage && varImgSrc) {
          variantSheetImage.innerHTML = `<img src="${varImgSrc}" alt="${_sheetProductData.title}">`;
        }
      } else {
        _sheetSelectedVariant = null;
      }

      updateSheetAtcState();
      haptic(10);
    });
  }

  // Handle sheet ATC click
  if (variantSheetAtc) {
    variantSheetAtc.addEventListener('click', async () => {
      if (!_sheetSelectedVariant || !_sheetSelectedVariant.available) return;

      const atcBtnOriginalHTML = variantSheetAtc.innerHTML;
      variantSheetAtc.classList.add('is-loading');
      variantSheetAtc.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" class="product-card__atc-spinner"><circle cx="12" cy="12" r="10" stroke-dasharray="31.4 31.4" /></svg>';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: _sheetSelectedVariant.id, quantity: 1 }),
        });

        if (!res.ok) throw new Error('Failed');

        // Update cart count
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const badge = document.getElementById('header-cart-count');
        const drawerCount = document.getElementById('cart-drawer-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = '';
        }
        if (drawerCount) drawerCount.textContent = cart.item_count;

        // Success state
        variantSheetAtc.classList.remove('is-loading');
        variantSheetAtc.classList.add('is-success');
        variantSheetAtc.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Aggiunto!';
        haptic([15, 80, 15]);
        playSuccessChime();

        // Refresh cart DOM
        requestBackgroundRefresh();

        // Close sheet after brief delay
        setTimeout(() => {
          closeVariantSheet();
          variantSheetAtc.classList.remove('is-success');
          variantSheetAtc.innerHTML = atcBtnOriginalHTML;
        }, 1200);

      } catch (err) {
        variantSheetAtc.classList.remove('is-loading');
        variantSheetAtc.innerHTML = atcBtnOriginalHTML;
      }
    });
  }

  /* ── Product Card Quick Add to Cart ──────────────────── */
  document.addEventListener('click', async (e) => {
    const atcBtn = e.target.closest('.product-card__atc[data-variant-id]');
    if (!atcBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = atcBtn.dataset.variantId;
    if (!variantId) return;

    const variantCount = parseInt(atcBtn.dataset.variantCount || '1');
    const productHandle = atcBtn.dataset.productHandle;

    // If product has multiple variants, open the variant picker sheet
    if (variantCount > 1 && productHandle) {
      // Fetch full product data
      try {
        const pRes = await fetch(`/products/${productHandle}.js`);
        const product = await pRes.json();
        if (product.variants && product.variants.length > 1) {
          _sheetOriginBtn = atcBtn;
          renderVariantSheet(product);
          return;
        }
      } catch (err) {
        // Fall through to direct add
      }
    }

    // Single variant — direct add (existing behavior)
    if (atcBtn.classList.contains('product-card__atc--adding') ||
        atcBtn.classList.contains('product-card__atc--added')) return;

    const originalSvg = atcBtn.innerHTML;

    atcBtn.classList.add('product-card__atc--adding');
    haptic(10);
    atcBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" class="product-card__atc-spinner"><circle cx="12" cy="12" r="10" stroke-dasharray="31.4 31.4" /></svg>';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
      });

      if (!res.ok) throw new Error('Failed');

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const badge = document.getElementById('header-cart-count');
      const drawerCount = document.getElementById('cart-drawer-count');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = '';
      } else {
        const cartIcon = document.getElementById('cart-toggle');
        if (cartIcon) {
          const span = document.createElement('span');
          span.className = 'header__badge';
          span.id = 'header-cart-count';
          span.textContent = cart.item_count;
          cartIcon.appendChild(span);
        }
      }
      if (drawerCount) drawerCount.textContent = cart.item_count;

      atcBtn.classList.remove('product-card__atc--adding');
      atcBtn.classList.add('product-card__atc--added');
      haptic([15, 80, 15]);
      playSuccessChime();
      atcBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

      requestBackgroundRefresh();
      setTimeout(() => openCart(), 600);

      setTimeout(() => {
        atcBtn.classList.remove('product-card__atc--added');
        atcBtn.innerHTML = originalSvg;
      }, 3000);
    } catch (err) {
      atcBtn.classList.remove('product-card__atc--adding');
      atcBtn.innerHTML = originalSvg;
    }
  });

  /* ── Shop the Look — Split Layout Interactions ────────── */
  function initShopTheLook() {
    const canvas = document.getElementById('shop-look-canvas');
    if (!canvas) return;
    const dots = canvas.querySelectorAll('.shop-look__dot');
    const products = canvas.querySelectorAll('.shop-look__product');
    const detailPanels = canvas.querySelectorAll('.shop-look__detail-panel');

    const setActive = (index) => {
      dots.forEach(d => d.classList.toggle('is-active', d.dataset.hotspotIndex === String(index)));
      products.forEach(p => {
        const isMatch = p.dataset.productIndex === String(index);
        p.classList.toggle('is-active', isMatch);
        if (isMatch) {
          p.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
      let hasActive = false;
      detailPanels.forEach(panel => {
        const isActive = panel.dataset.detailIndex === String(index);
        panel.classList.toggle('is-active', isActive);
        if (isActive) hasActive = true;
      });
      const detailContainer = document.getElementById('shop-look-detail');
      if (detailContainer) {
        detailContainer.style.display = hasActive ? 'block' : 'none';
      }
    };

    const detailContainer = document.getElementById('shop-look-detail');
    if (detailContainer) detailContainer.style.display = 'none';

    // Click dot → highlight product
    dots.forEach(dot => {
      dot.addEventListener('click', () => setActive(dot.dataset.hotspotIndex));
    });

    // Click product row → highlight dot
    products.forEach(product => {
      product.addEventListener('click', (e) => {
        if (e.target.closest('a') || e.target.closest('button')) return;
        setActive(product.dataset.productIndex);
      });
    });

    // Shop the Look ATC (delegated, safe to rebind)
    canvas.addEventListener('click', async (e) => {
      const atcBtn = e.target.closest('.shop-look__product-atc[data-variant-id]');
      if (!atcBtn) return;

      e.preventDefault();
      e.stopPropagation();

      const variantId = atcBtn.dataset.variantId;
      if (!variantId || atcBtn.classList.contains('shop-look__product-atc--added')) return;

      const originalHTML = atcBtn.innerHTML;
      haptic(10);
      atcBtn.textContent = '...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
        });
        if (!res.ok) throw new Error('Failed');

        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const badge = document.getElementById('header-cart-count');
        if (badge) { badge.textContent = cart.item_count; badge.style.display = ''; }

        atcBtn.classList.add('shop-look__product-atc--added');
        haptic([15, 80, 15]);
        playSuccessChime();
        atcBtn.innerHTML = '✓ Aggiunto';

        // Refresh cart DOM contents
        requestBackgroundRefresh();

        setTimeout(() => openCart(), 600);
      } catch (err) {
        atcBtn.innerHTML = originalHTML;
      }
    });
  }
  initShopTheLook();
  /* ── Universal Interactive Glow & Parallax ────────────── */
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const interactiveCards = document.querySelectorAll('.footer__newsletter, .contact-info-block, .product-card__visual, .category-strip__svg-icon, .shop-look__dot, .hero, .btn, .pdp__atc, .pdp__checkout-btn, .newsletter__btn, .shop-look__product-atc, .collection-toolbar__btn, .collection-pagination__btn, .header__dropdown-item, .jdgm-media-card');
  
  // Tracks the card currently under the cursor. Previously every card attached
  // its OWN window scroll listener (40-80 of them on a collection page), each
  // doing a getBoundingClientRect() mid-scroll. Now there is a single listener
  // that merely marks the hovered card's cached rect stale — the mousemove rAF
  // below already recomputes it lazily when it is null, so scrolling performs
  // no layout reads at all.
  let hoveredCard = null;
  window.addEventListener('scroll', () => {
    if (hoveredCard) hoveredCard.rect = null;
  }, { passive: true });

  interactiveCards.forEach(card => {
    // Held in an object so the shared scroll listener can invalidate it.
    const state = { rect: null };
    let ticking = false;

    card.addEventListener('mouseenter', () => {
      hoveredCard = state;
      state.rect = card.getBoundingClientRect();
    }, { passive: true });

    card.addEventListener('mouseleave', () => {
      if (hoveredCard === state) hoveredCard = null;
    }, { passive: true });

    card.addEventListener('mousemove', e => {
      if (!ticking) {
        requestAnimationFrame(() => {
          if (!state.rect) state.rect = card.getBoundingClientRect();
          const x = e.clientX - state.rect.left;
          const y = e.clientY - state.rect.top;
          card.style.setProperty('--mouse-x', `${x}px`);
          card.style.setProperty('--mouse-y', `${y}px`);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    /* ── Touch support: position spotlight on tap/drag ── */
    if (isTouchDevice) {
      card.addEventListener('touchstart', e => {
        const touch = e.touches[0];
        state.rect = card.getBoundingClientRect();
        const x = touch.clientX - state.rect.left;
        const y = touch.clientY - state.rect.top;
        card.style.setProperty('--mouse-x', `${x}px`);
        card.style.setProperty('--mouse-y', `${y}px`);
      }, { passive: true });

      card.addEventListener('touchmove', e => {
        if (!ticking) {
          requestAnimationFrame(() => {
            const touch = e.touches[0];
            if (!state.rect) state.rect = card.getBoundingClientRect();
            const x = touch.clientX - state.rect.left;
            const y = touch.clientY - state.rect.top;
            card.style.setProperty('--mouse-x', `${x}px`);
            card.style.setProperty('--mouse-y', `${y}px`);
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
      /* Scroll-based wandering spotlight removed for mobile performance.
         The spotlight still responds to direct touch (above). */
    }
  });

  // Delegated mouse tracking for review cards injected after load (the ones
  // present at load are already covered by interactiveCards above).
  // rAF-gated: this previously did a layout read plus two style writes on every
  // single mousemove anywhere on the page.
  let jdgmTicking = false;
  document.addEventListener('mousemove', e => {
    if (jdgmTicking) return;
    const target = e.target.closest && e.target.closest('.jdgm-media-card');
    if (!target) return;
    jdgmTicking = true;
    const cx = e.clientX, cy = e.clientY;
    requestAnimationFrame(() => {
      const rect = target.getBoundingClientRect();
      target.style.setProperty('--mouse-x', `${cx - rect.left}px`);
      target.style.setProperty('--mouse-y', `${cy - rect.top}px`);
      jdgmTicking = false;
    });
  }, { passive: true });

  /* ── Hero Liquid Parallax (Image Only) ────────────────── */
  const heroSection = document.querySelector('.hero');
  const heroImageBg = document.querySelector('.hero__image');
  
  if (heroSection && heroImageBg && !heroSection.querySelector('video')) {
    let tickingHero = false;

    heroSection.addEventListener('mousemove', e => {
      if (!tickingHero) {
        requestAnimationFrame(() => {
          // Calculate normalized X and Y (-1 to 1) from the center of the screen
          const xNorm = (e.clientX / window.innerWidth) * 2 - 1;
          const yNorm = (e.clientY / window.innerHeight) * 2 - 1;
          
          // We limit to max 1.5% translation on each axis around the 50% center
          const posX = 50 + (xNorm * -1.5);
          const posY = 50 + (yNorm * -1.5);

          heroImageBg.style.backgroundPosition = `${posX}% ${posY}%`;
          tickingHero = false;
        });
        tickingHero = true;
      }
    }, { passive: true });

    heroSection.addEventListener('mouseleave', () => {
      requestAnimationFrame(() => {
        heroImageBg.style.backgroundPosition = `50% 50%`;
      });
    }, { passive: true });

    /* ── Gyroscope Parallax for Mobile ── */
    if (isTouchDevice && window.DeviceOrientationEvent) {
      let gyroEnabled = false;
      let gyroSmooth = { x: 50, y: 50 };

      const handleOrientation = (e) => {
        if (!gyroEnabled) return;
        const gamma = e.gamma || 0; // left-right tilt (-90 to 90)
        const beta = e.beta || 0;   // front-back tilt (-180 to 180)
        
        // Normalize: gamma maps ±15° to ±1.5%, beta around 45° (natural hold angle)
        const targetX = 50 + Math.max(-1.5, Math.min(1.5, (gamma / 15) * -1.5));
        const targetY = 50 + Math.max(-1.5, Math.min(1.5, ((beta - 45) / 15) * -1.5));
        
        // Smooth interpolation for buttery motion
        gyroSmooth.x += (targetX - gyroSmooth.x) * 0.08;
        gyroSmooth.y += (targetY - gyroSmooth.y) * 0.08;
        
        heroImageBg.style.backgroundPosition = `${gyroSmooth.x}% ${gyroSmooth.y}%`;
      };

      // iOS 13+ requires permission
      if (typeof DeviceOrientationEvent.requestPermission === 'function') {
        // Request on first tap anywhere on the hero
        heroSection.addEventListener('touchstart', function requestGyro() {
          DeviceOrientationEvent.requestPermission()
            .then(state => {
              if (state === 'granted') {
                gyroEnabled = true;
                window.addEventListener('deviceorientation', handleOrientation, { passive: true });
              }
            })
            .catch(() => {});
          heroSection.removeEventListener('touchstart', requestGyro);
        }, { once: true });
      } else {
        // Android and older iOS — no permission needed
        gyroEnabled = true;
        window.addEventListener('deviceorientation', handleOrientation, { passive: true });
      }
    }
  }

  /* ── Atlantide Wave Mesh (3D Hover Effect) ─────────────── */
  (function initAtlantideWaves() {
    const canvases = document.querySelectorAll('[data-wave-canvas]');
    if (!canvases.length) return;

    // Users who ask for less motion (OS setting, common on kiosks/store demo
    // devices) get no animation at all — a single calm static frame.
    const prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    canvases.forEach(canvas => {
      // Guard against double-init: shopify:section:load re-runs this whole
      // function over the entire document, which would attach a SECOND rAF
      // loop + listeners to canvases already running and multiply the cost.
      if (canvas.dataset.waveInit) return;
      canvas.dataset.waveInit = '1';

      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      const section = canvas.closest('section') || canvas.parentElement;

      /* ── Adaptive quality tiers ───────────────────────────
         The old code ran a fixed, very dense grid (9px spacing ≈ 25k points/
         frame) on every non-phone device. Weak tablet PCs (e.g. a Surface in
         landscape, width > 768) and Firefox (GC-sensitive) couldn't keep up and
         dragged the whole page down. We now start at a quality tier chosen from
         the device's capability and AUTO-DEGRADE if we measure that a frame is
         costing too much — so unknown weak hardware recovers on its own. */
      // fps values are kept to divisors of 60: a rAF-based cap can only skip
      // whole frames, so an "in between" target like 40 silently renders at 30
      // anyway. Stating the rate we actually get keeps the budget maths honest.
      const TIERS = [
        { spacing: 11, dprCap: 2,   foam: true,  fps: 60 }, // 0 — full desktop
        { spacing: 15, dprCap: 1.5, foam: true,  fps: 30 }, // 1 — medium
        { spacing: 21, dprCap: 1,   foam: false, fps: 20 }, // 2 — light
      ];
      const cores = navigator.hardwareConcurrency || 4;
      // Pick the tier from capability, NOT from width alone. A touch/coarse-pointer
      // device or a low-core CPU deserves a lighter tier even on a wide screen —
      // this is what the Surface tablet was missing. Recomputed on resize, since
      // a tablet rotating (or a window being narrowed) changes the answer.
      function baselineTier() {
        const coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
        if (cores <= 2) return 2;
        if (coarse || isTouchDevice || cores <= 4 || window.innerWidth < 768) return 1;
        return 0;
      }
      // Lowest quality the watchdog has forced. Only ever raised, so a device that
      // proved too slow is never quietly promoted back on the next resize.
      let watchdogFloor = 0;
      let tierIndex = baselineTier();
      let tier = TIERS[tierIndex];

      // Returns true when the active tier actually changed.
      function refreshTier() {
        const want = Math.max(baselineTier(), watchdogFloor);
        if (want === tierIndex) return false;
        tierIndex = want;
        tier = TIERS[tierIndex];
        return true;
      }

      /* ── Configuration ─── */
      let isMobileCanvas = window.innerWidth < 768; // re-evaluated on resize
      let COLS = 260;                // horizontal grid points (dynamic based on screen width)
      let ROWS = 130;                // vertical grid points (dynamic based on screen height)
      const BASE_AMP = 22;           // idle wave amplitude
      const HOVER_AMP = 95;          // wave boost near cursor/virtual focal point
      const HOVER_RADIUS = 300;      // px radius of influence
      const SPEED = 0.006;           // wave propagation speed (per 60fps-equivalent frame)
      const LINE_ALPHA = 0.05;       // mesh line opacity

      let mouse = { x: -9999, y: -9999 };
      let mouseSmooth = { x: -9999, y: -9999 };
      let isHovering = false;
      let hoverIntensity = 0;
      let isVisible = false;
      let raf = null;
      let time = 0;

      // Flat, reused grid buffers. The old code allocated ~25k {x,y,wave}
      // objects EVERY frame, which is the main reason Firefox stuttered (GC).
      // These are reallocated only when the grid dimensions change (resize).
      let px = null, py = null, pw = null;
      let lastParallaxX = null, lastParallaxY = null;

      /* ── Off-screen Foam Texture ─── */
      // Pre-renders a very soft, large, subtle white radial gradient to use as "sea mist" foam shading 
      const foamSize = 100;
      const foamCanvas = document.createElement('canvas');
      foamCanvas.width = foamSize; 
      foamCanvas.height = foamSize;
      const fctx = foamCanvas.getContext('2d');
      const fgrd = fctx.createRadialGradient(foamSize/2, foamSize/2, 0, foamSize/2, foamSize/2, foamSize/2);
      
      // We significantly lower the opacity compared to the original version
      // so the overlaps create a smooth, subtle mist rather than an overpowering white 'blob'
      fgrd.addColorStop(0, 'rgba(255, 255, 255, 0.04)');     
      fgrd.addColorStop(0.3, 'rgba(50, 220, 230, 0.02)');    
      fgrd.addColorStop(1, 'rgba(0, 100, 150, 0)');          
      fctx.fillStyle = fgrd;
      fctx.fillRect(0, 0, foamSize, foamSize);

      /* ── Resize handling ─── */
      let W, H, spacingX, spacingY;
      function resize() {
        // Keep mobile/desktop mode in sync when the viewport crosses 768px
        // (e.g. tablet rotation) so DPR cap and grid density stay correct
        isMobileCanvas = window.innerWidth < 768;
        // DPR is capped per quality tier — lower tiers use fewer backing pixels.
        const dpr = Math.min(window.devicePixelRatio || 1, tier.dprCap);

        // Calculate literal pixel width resolving from bulletproof CSS boundaries
        const canvasRect = canvas.getBoundingClientRect();
        W = canvasRect.width;
        H = canvasRect.height;

        canvas.width = W * dpr;
        canvas.height = H * dpr;

        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

        // Grid density comes from the active quality tier. Coarser spacing on
        // weaker devices means quadratically fewer points to compute per frame.
        const targetSpacing = tier.spacing;
        COLS = Math.max(2, Math.ceil(W / targetSpacing));
        ROWS = Math.max(2, Math.ceil(H / targetSpacing));

        // Grid naturally fills the oversized canvas
        spacingX = W / (COLS - 1);
        spacingY = H / (ROWS - 1);

        // (Re)allocate the flat point buffers only when the count changes.
        const n = COLS * ROWS;
        if (!px || px.length !== n) {
          px = new Float32Array(n);
          py = new Float32Array(n);
          pw = new Float32Array(n);
        }
      }
      resize();
      // Debounced: resize() reallocates the canvas backing store and the point
      // buffers, so running it on every resize event (a window drag fires
      // dozens per second) would thrash memory mid-animation.
      let resizeTimer = null;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          // A rotation or window resize can change which tier this device
          // deserves (e.g. a tablet crossing 768px), so re-evaluate first.
          refreshTier();
          resize();
          // Setting canvas.width clears the bitmap. With no animation loop
          // running (reduced motion) nothing would ever repaint it, so redraw
          // the single static frame here.
          if (prefersReducedMotion) render();
        }, 150);
      }, { passive: true });

      // Called by the auto-degrade watchdog when frames cost too much.
      // Recorded as a floor so a later resize cannot undo the degradation.
      function applyTier(index) {
        watchdogFloor = Math.max(watchdogFloor, index);
        refreshTier();
        resize();
      }

      /* ── Mouse tracking ─── */
      section.addEventListener('mouseenter', () => { isHovering = true; }, { passive: true });
      section.addEventListener('mouseleave', () => {
        isHovering = false;
      }, { passive: true });
      section.addEventListener('mousemove', e => {
        // Compute tracking position against the canvas bounding rect, NOT the section rect.
        // This ensures tracking perfectly aligns internally even when the canvas is physically expanded off-screen.
        const rect = canvas.getBoundingClientRect();
        mouse.x = e.clientX - rect.left;
        mouse.y = e.clientY - rect.top;
      }, { passive: true });

      /* ── Touch tracking for mobile (finger-responsive waves) ─── */
      if (isTouchDevice) {
        // Make canvas area respond to touch by enabling pointer-events on the section
        section.addEventListener('touchstart', e => {
          isHovering = true;
          const touch = e.touches[0];
          const rect = canvas.getBoundingClientRect();
          mouse.x = touch.clientX - rect.left;
          mouse.y = touch.clientY - rect.top;
        }, { passive: true });

        section.addEventListener('touchmove', e => {
          const touch = e.touches[0];
          const rect = canvas.getBoundingClientRect();
          mouse.x = touch.clientX - rect.left;
          mouse.y = touch.clientY - rect.top;
        }, { passive: true });

        section.addEventListener('touchend', () => {
          // Gradually fade out the interaction (don't snap immediately)
          isHovering = false;
          // Let mouseSmooth interpolation handle the fade-out naturally
          setTimeout(() => {
            if (!isHovering) {
              mouse.x = -9999;
              mouse.y = -9999;
            }
          }, 1500); // 1.5s delay so waves settle naturally
        }, { passive: true });
      }

      /* ── Scroll triggering removed on mobile for performance ─── */
      /* The wave canvas now runs a calm idle animation on mobile instead of
         reacting to scroll. Touch interaction (touchstart/touchmove above)
         still creates the hover surge when the user directly touches the section. */

      /* ── Visibility observer (perf) ─── */
      const visObserver = new IntersectionObserver(entries => {
        entries.forEach(e => {
          isVisible = e.isIntersecting;
          // tick() takes the rAF timestamp, so always (re)enter through rAF
          // rather than calling it directly with an undefined `now`.
          if (isVisible && !raf && !prefersReducedMotion) {
            lastFrame = 0; // don't count the paused interval as elapsed time
            raf = requestAnimationFrame(tick);
          }
          if (!isVisible && raf) { cancelAnimationFrame(raf); raf = null; }
        });
      }, { threshold: 0.05 });
      visObserver.observe(section);

      /* ── Calculate point position (writes into the flat buffers) ─── */
      function computePoint(col, row, t, i) {
        const baseX = col * spacingX;
        const baseY = row * spacingY;

        // 1. Primary Swell (Intersecting / Crossing waves for sharp crests)
        const dirA = col * 0.07 + row * 0.04 - t * 0.5;
        const waveA = Math.sin(dirA);
        
        const dirB = -col * 0.05 + row * 0.06 - t * 0.6;
        const waveB = Math.sin(dirB);
        
        // Combine and sharpen the peaks when they perfectly intersect
        const crestBase = (waveA + waveB + 2) / 4; 
        const wave1 = (Math.pow(crestBase, 1.8) * 4.0 - 1.0) * 1.2;

        // 2. Secondary Ripples (Subtle medium ripples)
        const wave2 = Math.sin(col * 0.16 - t * 0.8 + row * 0.12) * 0.15;
        
        // 3. Tertiary Surface Chop (High frequency, subtle ambient motion)
        const wave3 = Math.cos(row * 0.28 + t * 1.2 + col * 0.22) * 0.08;
        
        // 4. Micro-foam chop (Very high freq, minimal height)
        const wave4 = Math.sin(col * 0.45 - t * 1.8 - row * 0.35) * 0.03;

        let amp = BASE_AMP;

        // Mouse proximity boost
        const dx = mouseSmooth.x - baseX;
        const dy = mouseSmooth.y - baseY;
        const dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < HOVER_RADIUS) {
          const proximity = 1 - (dist / HOVER_RADIUS);
          const eased = proximity * proximity * (3 - 2 * proximity); // smoothstep
          amp += HOVER_AMP * eased * hoverIntensity; // Gracefully fade surge using hoverIntensity
        }

        const compositeWave = wave1 + wave2 + wave3 + wave4;
        const offsetY = compositeWave * amp;
        const offsetX = Math.sin(row * 0.14 + t * 0.5) * amp * 0.3;

        // Multiply the foam trigger by hoverIntensity so it stays dark and calm when idle, but blasts white when scrolling
        const dynamicFoamScale = 1.0 + (hoverIntensity * 1.8);

        px[i] = baseX + offsetX;
        py[i] = baseY + offsetY;
        pw[i] = Math.max(-1, Math.min(1, (compositeWave / 2.6) * dynamicFoamScale));
      }

      /* ── Render frame ─── */
      function render() {
        ctx.clearRect(0, 0, W, H);

        // Smooth mouse interpolation & Parallax injection
        const lerp = isHovering ? 0.08 : 0.04;
        // Mobile: auto-wandering virtual cursor for crest effect (no interaction needed)
        if (isMobileCanvas) {
          // Slowly drift a focal point across the canvas using time
          mouseSmooth.x = W * (0.5 + 0.4 * Math.sin(time * 0.3));
          mouseSmooth.y = H * (0.5 + 0.35 * Math.cos(time * 0.22));
          hoverIntensity = 1.0; // Full desktop-strength crests
        } else {
          mouseSmooth.x += (mouse.x - mouseSmooth.x) * lerp;
          mouseSmooth.y += (mouse.y - mouseSmooth.y) * lerp;
          hoverIntensity += ((isHovering ? 1 : 0) - hoverIntensity) * 0.05;
          // Desktop only: subtle canvas parallax on hover. Only touch the style
          // when it actually moves — a per-frame transform write on an idle
          // section forces needless compositing work.
          if (mouseSmooth.x > 0) {
            const parallaxX = Math.round((mouseSmooth.x - (W / 2)) * -0.015);
            const parallaxY = Math.round((mouseSmooth.y - (H / 2)) * -0.015);
            if (parallaxX !== lastParallaxX || parallaxY !== lastParallaxY) {
              lastParallaxX = parallaxX;
              lastParallaxY = parallaxY;
              canvas.style.transform = `translate(${parallaxX}px, ${parallaxY}px)`;
            }
          }
        }

        // Fill the reused flat buffers (index = r * COLS + c).
        let i = 0;
        for (let r = 0; r < ROWS; r++) {
          for (let c = 0; c < COLS; c++) {
            computePoint(c, r, time, i++);
          }
        }

        // Gradient stroke styles for crest effect (renders on all devices)
        let hLineStyle = `rgba(255,255,255,${LINE_ALPHA})`;
        let vLineStyle = `rgba(255,255,255,${LINE_ALPHA * 0.7})`;

        if (hoverIntensity > 0.01 && mouseSmooth.x > -100) {
           hLineStyle = ctx.createRadialGradient(
             mouseSmooth.x, mouseSmooth.y, 0,
             mouseSmooth.x, mouseSmooth.y, HOVER_RADIUS * 1.5
           );
           hLineStyle.addColorStop(0, `rgba(255, 255, 255, ${LINE_ALPHA * (1 + 4.0 * hoverIntensity)})`);
           hLineStyle.addColorStop(0.4, `rgba(255, 255, 255, ${LINE_ALPHA * (1 + 1.0 * hoverIntensity)})`);
           hLineStyle.addColorStop(1, `rgba(255, 255, 255, ${LINE_ALPHA})`);

           vLineStyle = ctx.createRadialGradient(
             mouseSmooth.x, mouseSmooth.y, 0,
             mouseSmooth.x, mouseSmooth.y, HOVER_RADIUS * 1.5
           );
           vLineStyle.addColorStop(0, `rgba(255, 255, 255, ${LINE_ALPHA * (0.7 + 2.8 * hoverIntensity)})`);
           vLineStyle.addColorStop(0.4, `rgba(255, 255, 255, ${LINE_ALPHA * (0.7 + 0.8 * hoverIntensity)})`);
           vLineStyle.addColorStop(1, `rgba(255, 255, 255, ${LINE_ALPHA * 0.7})`);
        }

        // Draw all horizontal lines as ONE path with a single stroke() —
        // per-row strokes meant ROWS+COLS (~300) stroke calls per frame,
        // which is what made Firefox choke. Same style ⇒ same rendering.
        ctx.lineWidth = 0.8;
        ctx.beginPath();
        for (let r = 0; r < ROWS; r++) {
          const rowBase = r * COLS;
          for (let c = 0; c < COLS; c++) {
            const idx = rowBase + c;
            if (c === 0) ctx.moveTo(px[idx], py[idx]);
            else ctx.lineTo(px[idx], py[idx]);
          }
        }
        ctx.strokeStyle = hLineStyle;
        ctx.stroke();

        // Draw all vertical lines as one path too
        ctx.beginPath();
        for (let c = 0; c < COLS; c++) {
          for (let r = 0; r < ROWS; r++) {
            const idx = r * COLS + c;
            if (r === 0) ctx.moveTo(px[idx], py[idx]);
            else ctx.lineTo(px[idx], py[idx]);
          }
        }
        ctx.strokeStyle = vLineStyle;
        ctx.stroke();

        // Wave crest foam mist — the most expensive pass (many composited
        // drawImage calls), so the lightest quality tier skips it entirely.
        if (tier.foam) {
          // Mobile: step every 8th node (vs 5th on desktop) for fewer drawImage calls
          // Mobile: lower threshold (0.30 vs 0.50) since no hover boost on mobile
          const foamStep = isMobileCanvas ? 8 : 5;
          const foamThreshold = isMobileCanvas ? 0.30 : 0.50;
          ctx.globalCompositeOperation = 'screen';

          for (let r = 0; r < ROWS; r += foamStep) {
            const rowBase = r * COLS;
            for (let c = 0; c < COLS; c += foamStep) {
              const idx = rowBase + c;
              const wave = pw[idx];
              if (wave > foamThreshold) {
                const intensity = Math.min(1, (wave - foamThreshold) / (1.0 - foamThreshold));
                // Mobile: slightly smaller foam for performance
                const sizeScale = isMobileCanvas ? 0.7 : 1.0;
                const activeSize = foamSize * (0.8 + 1.2 * intensity) * sizeScale;
                ctx.globalAlpha = Math.min(1, intensity * 0.8);
                ctx.drawImage(
                  foamCanvas,
                  px[idx] - activeSize / 2,
                  py[idx] - activeSize / 2,
                  activeSize,
                  activeSize
                );
              }
            }
          }
          ctx.globalAlpha = 1.0;
          ctx.globalCompositeOperation = 'source-over';
        }

        // Ambient light effects — always render (cheap: one gradient fill)
        ctx.globalCompositeOperation = 'screen';

        const ambientGrad = ctx.createLinearGradient(0, 0, W, H);
        const shift1 = Math.sin(time * 2.0) * 0.005;
        const shift2 = Math.cos(time * 1.5) * 0.005;
        ambientGrad.addColorStop(0, `rgba(255, 255, 255, ${0.01 + shift1})`);
        ambientGrad.addColorStop(0.5, 'transparent');
        ambientGrad.addColorStop(1, `rgba(255, 255, 255, ${0.01 + shift2})`);
        ctx.fillStyle = ambientGrad;
        ctx.fillRect(0, 0, W, H);

        // Cursor glow — desktop only
        if (!isMobileCanvas && hoverIntensity > 0.01 && mouseSmooth.x > -100) {
          const hoverGrad = ctx.createRadialGradient(
            mouseSmooth.x, mouseSmooth.y, 0,
            mouseSmooth.x, mouseSmooth.y, HOVER_RADIUS * 3.5
          );
          hoverGrad.addColorStop(0, `rgba(255, 255, 255, ${0.03 * hoverIntensity})`);
          hoverGrad.addColorStop(0.3, `rgba(255, 255, 255, ${0.015 * hoverIntensity})`);
          hoverGrad.addColorStop(1, 'transparent');
          ctx.fillStyle = hoverGrad;
          ctx.fillRect(0, 0, W, H);
        }

        ctx.globalCompositeOperation = 'source-over';

      }

      /* ── Animation loop ───────────────────────────────────
         Two protections the old loop lacked:
         1. An FPS cap per tier — an uncapped rAF loop on a 120Hz tablet asked
            for double the work for no visible gain.
         2. A watchdog that measures how long render() actually takes and drops
            to a lighter tier when the device can't keep up. This is what saves
            unknown weak hardware (the Surface tablet) without us having to
            detect it by name or screen size. */
      let lastFrame = 0;
      let slowFrames = 0;

      function tick(now) {
        raf = requestAnimationFrame(tick);

        const minDelta = 1000 / tier.fps;
        if (!lastFrame) lastFrame = now;
        const delta = now - lastFrame;
        if (delta < minDelta - 1) return; // skip: too soon for this tier's cap
        lastFrame = now;

        // Advance wave time by real elapsed time so the animation runs at the
        // same visual speed regardless of the tier's frame rate. Clamped so a
        // long stall (background tab) doesn't jump the waves.
        time += SPEED * Math.min(delta / 16.667, 3);

        const t0 = performance.now();
        render();
        const cost = performance.now() - t0;

        // Degrade after a run of frames that each cost more than ~60% of the
        // tier's frame budget — a sustained signal, not one unlucky frame.
        if (tierIndex < TIERS.length - 1) {
          if (cost > minDelta * 0.6) {
            if (++slowFrames >= 20) {
              slowFrames = 0;
              applyTier(tierIndex + 1);
            }
          } else if (slowFrames > 0) {
            slowFrames--;
          }
        }
      }

      if (prefersReducedMotion) {
        // Draw one calm static frame and stop — no rAF loop at all.
        render();
      } else if (isVisible || section.getBoundingClientRect().top < window.innerHeight) {
        // Start if already visible
        isVisible = true;
        raf = requestAnimationFrame(tick);
      }
    });

    // Re-init on Shopify editor section render. initAtlantideWaves() re-scans
    // the whole document, but the data-waveInit guard above means already-running
    // canvases are skipped and only the newly rendered one starts a loop.
    document.addEventListener('shopify:section:load', (e) => {
      const newCanvases = e.target.querySelectorAll('[data-wave-canvas]');
      if (newCanvases.length) initAtlantideWaves();
    });
  })();

  // Global initialization for all sliders on page load
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.cart-rec__slider').forEach(slider => {
      initDraggableSlider(slider);
    });

    /* ── Product Carousel (arrows, dots, drag) ─────────── */
    document.querySelectorAll('.product-carousel').forEach(carousel => {
      const track = carousel.querySelector('[data-carousel-track]');
      const prevBtn = carousel.querySelector('[data-carousel-prev]');
      const nextBtn = carousel.querySelector('[data-carousel-next]');
      const dotsContainer = carousel.querySelector('[data-carousel-dots]');
      if (!track) return;

      // Enable drag-to-scroll on desktop
      initDraggableSlider(track);

      const cards = track.querySelectorAll('.product-card');
      const cardCount = cards.length;
      if (cardCount === 0) return;

      // Calculate how many cards are visible at once
      const getVisibleCount = () => {
        const cardW = cards[0].offsetWidth + 12; // card width + gap
        return Math.max(1, Math.floor(track.offsetWidth / cardW));
      };

      // Total "pages" for dot navigation
      const getPageCount = () => Math.max(1, cardCount - getVisibleCount() + 1);

      // Current page based on scroll position
      const getCurrentPage = () => {
        const cardW = cards[0].offsetWidth + 12;
        return Math.round(track.scrollLeft / cardW);
      };

      // Build dots
      const buildDots = () => {
        if (!dotsContainer) return;
        const pages = getPageCount();
        dotsContainer.innerHTML = '';
        for (let i = 0; i < pages; i++) {
          const dot = document.createElement('button');
          dot.className = 'product-carousel__dot' + (i === 0 ? ' is-active' : '');
          dot.dataset.page = i;
          dot.setAttribute('aria-label', `Pagina ${i + 1}`);
          dot.addEventListener('click', () => {
            const cardW = cards[0].offsetWidth + 12;
            track.scrollTo({ left: i * cardW, behavior: 'smooth' });
          });
          dotsContainer.appendChild(dot);
        }
      };

      // Update arrow visibility and dot active state
      const updateState = () => {
        const page = getCurrentPage();
        const maxScroll = track.scrollWidth - track.clientWidth;

        if (prevBtn) prevBtn.style.display = track.scrollLeft <= 5 ? 'none' : '';
        if (nextBtn) nextBtn.style.display = track.scrollLeft >= maxScroll - 5 ? 'none' : '';

        if (dotsContainer) {
          dotsContainer.querySelectorAll('.product-carousel__dot').forEach((dot, i) => {
            dot.classList.toggle('is-active', i === page);
          });
        }
      };

      // Arrow click → scroll by one card
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          const cardW = cards[0].offsetWidth + 12;
          track.scrollBy({ left: -cardW, behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          const cardW = cards[0].offsetWidth + 12;
          track.scrollBy({ left: cardW, behavior: 'smooth' });
        });
      }

      // Track scroll position
      let scrollTimer;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateState, 60);
      }, { passive: true });

      // Init
      buildDots();
      updateState();

      // Rebuild on resize
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => { buildDots(); updateState(); }, 200);
      });
    });
  });

  /* ── Footer Accordion (mobile only) ─────────── */
  document.querySelectorAll('.footer__accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      // Only operate on mobile
      if (window.innerWidth >= 768) return;
      
      const body = trigger.closest('[data-footer-accordion]').querySelector('.footer__accordion-body');
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      
      // Close all other open accordions
      document.querySelectorAll('.footer__accordion-trigger[aria-expanded="true"]').forEach(other => {
        if (other !== trigger) {
          other.setAttribute('aria-expanded', 'false');
          const otherBody = other.closest('[data-footer-accordion]').querySelector('.footer__accordion-body');
          if (otherBody) otherBody.classList.remove('is-open');
        }
      });
      
      // Toggle this one
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (body) body.classList.toggle('is-open', !isOpen);
    });
  });

  /* ── Judge.me: Make product names clickable & elevated ─ */
  function enhanceJudgeMeProductLinks() {
    const containers = document.querySelectorAll('.jdgm-widget, .jdgm-review-widget, .jdgm-rev-widg, .jdgm-carousel, [class*="jdgm"]');
    
    containers.forEach(container => {
      // 1. Handle elements that are already links pointing to products
      const links = container.querySelectorAll('a[href*="/products/"]');
      links.forEach(link => {
        // The homepage Featured Reviews carousel is handled separately
        // (polishFeaturedReviewsCarousel) — don't elevate links there.
        if (link.closest('.jdgm-carousel')) return;
        const reviewEl = link.closest('.jdgm-rev, .jdgm-carousel-item, [class*="jdgm-rev"]');
        if (reviewEl && link.parentElement !== reviewEl) {
          // Move the link to the very top of the review card
          reviewEl.insertBefore(link, reviewEl.firstChild);
        }
        link.classList.add('jdgm-elevated-product-title');
      });

      // 2. Handle unlinked product names
      const candidates = container.querySelectorAll('.jdgm-rev__prod-title, .jdgm-rev__product-title, [class*="product-title"], [class*="prod-title"], [class*="product-name"]');
      candidates.forEach(el => {
        if (el.tagName === 'A' || el.closest('a')) return;
        if (el.closest('.jdgm-carousel')) return; // handled separately
        const productName = el.textContent.trim();
        if (!productName) return;
        
        const reviewEl = el.closest('.jdgm-rev, .jdgm-carousel-item, [class*="jdgm-rev"]');
        if (!reviewEl) return;
        
        // Move text wrapper to top
        reviewEl.insertBefore(el, reviewEl.firstChild);

        // Try to wrap it in a link if we can find the URL nearby
        const existingLink = reviewEl.querySelector('a[href*="/products/"]');
        if (existingLink) {
          const wrapper = document.createElement('a');
          wrapper.href = existingLink.href;
          wrapper.classList.add('jdgm-elevated-product-title');
          el.parentNode.insertBefore(wrapper, el);
          wrapper.appendChild(el);
        } else {
          el.classList.add('jdgm-elevated-product-title');
        }
      });

      // 3. Clean up generic Judge.me wrappers that are now empty at the bottom
      const wrappers = container.querySelectorAll('.jdgm-rev__prod-info, .jdgm-carousel-item__product-info');
      wrappers.forEach(w => {
        if (w.textContent.trim() === '' || w.children.length === 0) {
          w.style.display = 'none';
        }
      });
    });
  }

  /* ── Judge.me: polish the homepage Featured Reviews carousel ───
     Two things Judge.me does poorly that CSS alone can't fix:
       1. It requests tiny 100×100 image thumbnails, so they look
          blurry when displayed. We rewrite the URL to ask the CDN
          (Shopify / imgix) for a crisp 400px version.
       2. It places each card's footer elements inconsistently as it
          lazy-renders, so the order jumps around. We pin the product
          link to the end of every card → footer order is always
          reviewer name → date → product.
     Idempotent and re-run on Judge.me's async render via the observer. */
  function polishFeaturedReviewsCarousel() {
    document.querySelectorAll('.jdgm-carousel .jdgm-carousel-item').forEach(item => {
      const img = item.querySelector('img.jdgm-carousel-item__product-image');
      if (img) {
        // Judge.me lazy-loads these images: the real URL lives in data-src
        // and `src` is empty/placeholder until the slide scrolls into view.
        // Upscale the lazy sources AND a live src, but ONLY ever rewrite a
        // genuine CDN URL — never an empty / relative / placeholder src
        // (doing so previously broke the images). Idempotent: re-running on
        // an already-400px URL is a no-op.
        ['data-src', 'data-src-retina', 'src'].forEach(attr => {
          const val = img.getAttribute(attr);
          if (!val) return;
          let next = null;
          try {
            const u = new URL(val, location.href);
            if (u.hostname.indexOf('cdn.shopify.com') !== -1) {
              const p = u.pathname.replace(/_(\d+)x(\d+)(\.[a-z]+)$/i, '_400x400$3');
              if (p !== u.pathname) { u.pathname = p; next = u.toString(); }
            } else if (u.hostname.indexOf('imgix') !== -1) {
              u.searchParams.set('w', '400');
              u.searchParams.set('h', '400');
              u.searchParams.set('fit', 'clip');
              u.searchParams.set('dpr', '2');
              next = u.toString();
            }
          } catch (e) { /* malformed URL — leave it alone */ }
          if (next && next !== val) img.setAttribute(attr, next);
        });
      }
      // Group the reviewer name, date and product link into one footer
      // element, appended last. theme.css absolutely-positions this footer at
      // the bottom of the card, so it stays at a fixed position no matter how
      // long or short the review text is. Idempotent (safe to re-run on the
      // mutation observer): once everything is in the footer, nothing moves.
      const nameWrap = item.querySelector('.jdgm-carousel-item__reviewer-name-wrapper');
      const prod = item.querySelector('a.jdgm-carousel-item__product');
      let footer = null;
      for (const c of item.children) {
        if (c.classList && c.classList.contains('atl-rev-footer')) { footer = c; break; }
      }
      if (!footer) { footer = document.createElement('div'); footer.className = 'atl-rev-footer'; }
      if (nameWrap && nameWrap.parentElement !== footer) footer.appendChild(nameWrap);
      if (prod && prod.parentElement !== footer) footer.appendChild(prod);
      if (footer.parentElement !== item) item.appendChild(footer);
    });
  }

  // Judge.me emits <img data-src="..."> with no src and relies on its own
  // lazy-loader to promote it. That loader runs seconds late, so the carousel
  // paints broken-image icons in the meantime (measured on the live site).
  // Promote them ourselves and let the browser lazy-load natively: no broken
  // icon, and no eager bandwidth either.
  function fixJudgeMeLazyImages() {
    document.querySelectorAll('.jdgm-widget img[data-src]:not([src]), .jdgm-carousel img[data-src]:not([src])').forEach(img => {
      const src = img.getAttribute('data-src');
      if (!src) return;
      const retina = img.getAttribute('data-src-retina');
      if (retina && retina !== src) img.setAttribute('srcset', retina + ' 2x');
      img.loading = 'lazy';
      img.decoding = 'async';
      img.setAttribute('src', src);
    });
  }

  function runJudgeMeEnhancements() {
    fixJudgeMeLazyImages();
    enhanceJudgeMeProductLinks();
    polishFeaturedReviewsCarousel();
  }

  // Judge.me loads asynchronously, so watch for it
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      // Initial attempt + delayed retry for async Judge.me widget
      setTimeout(runJudgeMeEnhancements, 1500);
      setTimeout(runJudgeMeEnhancements, 4000);
    });
  } else {
    setTimeout(runJudgeMeEnhancements, 1500);
    setTimeout(runJudgeMeEnhancements, 4000);
  }

  // Also observe the DOM for Judge.me injecting content later.
  // This observer used to run for the whole session on every page and was never
  // disconnected: it woke on every cart-drawer rebuild, recommendation render and
  // toast, running an attribute-substring selector — the slowest kind — over each
  // injected subtree. It now stops as soon as the widget appears, and gives up
  // entirely on pages where Judge.me never loads.
  let jdgmGiveUp = null;
  const jdgmObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1 && (
          node.classList?.contains('jdgm-widget') ||
          node.classList?.contains('jdgm-rev-widg') ||
          node.querySelector?.('[class*="jdgm"]')
        )) {
          jdgmObserver.disconnect();
          clearTimeout(jdgmGiveUp);
          setTimeout(runJudgeMeEnhancements, 500);
          return;
        }
      }
    }
  });
  jdgmObserver.observe(document.body, { childList: true, subtree: true });
  // Most templates never render a review widget — don't watch them forever.
  jdgmGiveUp = setTimeout(() => jdgmObserver.disconnect(), 15000);

  /* ── Interactive 3D Parallax (Footer Logo & Promo Banner) ─────────────── */
  const footerLogos = document.querySelectorAll('.footer__logo, .footer__logo-text, .promo-banner');
  if (footerLogos.length > 0) {
    let tick = false;

    footerLogos.forEach(logo => {
      // Desktop mouse parallax
      logo.addEventListener('mousemove', (e) => {
        const rect = logo.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        
        // Map mouse position to [-20, 20] degrees
        const tiltX = (y / (rect.height / 2)) * -20;
        const tiltY = (x / (rect.width / 2)) * 20;

        logo.style.setProperty('--tilt-x', `${tiltX}deg`);
        logo.style.setProperty('--tilt-y', `${tiltY}deg`);
      });

      logo.addEventListener('mouseleave', () => {
        logo.style.setProperty('--tilt-x', '0deg');
        logo.style.setProperty('--tilt-y', '0deg');
      });
    });

    // Mobile gyroscope tilt
    let hasGyro = false;
    window.addEventListener('deviceorientation', (e) => {
      if (window.innerWidth >= 1024) return;
      if (tick || !e.gamma || !e.beta) return;
      hasGyro = true;
      tick = true;
      requestAnimationFrame(() => {
        let tiltY = e.gamma ? Math.max(-25, Math.min(25, e.gamma)) : 0; 
        let tiltX = e.beta ? Math.max(-25, Math.min(25, e.beta - 45)) : 0;
        
        footerLogos.forEach(logo => {
          logo.style.setProperty('--tilt-x', `${-tiltX}deg`);
          logo.style.setProperty('--tilt-y', `${tiltY}deg`);
        });
        tick = false;
      });
    }, { passive: true });

    // iOS / Fallback Scroll Parallax (Automatic 3D Card behavior)
    let scrollTick = false;
    window.addEventListener('scroll', () => {
      if (window.innerWidth >= 1024) {
        // Ensure properties are reset if resized back to desktop while scrolled
        if (!scrollTick) {
          footerLogos.forEach(logo => {
             if (!logo.matches(':hover')) {
               logo.style.setProperty('--tilt-x', '0deg');
               logo.style.setProperty('--tilt-y', '0deg');
             }
          });
        }
        return;
      }
      if (scrollTick || hasGyro) return;
      scrollTick = true;
      requestAnimationFrame(() => {
        footerLogos.forEach(logo => {
          const rect = logo.getBoundingClientRect();
          if (rect.top > window.innerHeight + 200 || rect.bottom < -200) return;

          const screenCenter = window.innerHeight / 2;
          const logoCenter = rect.top + rect.height / 2;
          
          const offset = Math.max(-1, Math.min(1, (logoCenter - screenCenter) / (window.innerHeight / 2)));
          
          const tiltX = offset * 35;
          const tiltY = offset * -12;
          
          logo.style.setProperty('--tilt-x', `${tiltX}deg`);
          logo.style.setProperty('--tilt-y', `${tiltY}deg`);
        });
        scrollTick = false;
      });
    }, { passive: true });
  }

})();
